<template>
  <div style="display: flex; justify-content: space-around; position: relative">
    <div class="logout-button-wrap" @click="menuClicked('Log Out')">
      <v-btn large text color="#000000"
        ><v-icon depressed color="#353c94">mdi-power</v-icon>&nbsp;
        Logout</v-btn
      >
    </div>
    <div
      class="text-center pt-2 pr-4"
      style="z-index: 2; position: absolute; right: 0"
      v-if="showMenu == 'Top'"
    >
      <v-menu
        min-width="100"
        v-model="menuExpandedState"
        open-on-hover
        offset-y
      >
        <template v-slot:activator="{ on, attrs }">
          <div v-bind="attrs" v-on="on">
            <v-avatar
              size="36"
              v-if="
                $store.state.user.length > 0 && $store.state.user[0].profilepic
              "
            >
              <img :src="$store.state.user[0].profilepic" alt="e2m" />
            </v-avatar>
            <v-avatar
              size="36"
              color="grey"
              v-else
              style="text-transform: uppercase"
            >
              {{ getInitials() }}
            </v-avatar>
            <span class="pl-2">{{ menuLabel }}</span>
            <v-icon v-if="!menuExpandedState">expand_more</v-icon>
            <v-icon v-else>expand_less</v-icon>
          </div>
        </template>
        <v-list>
          <v-list-item>
            <div>
              <v-avatar
                size="36"
                v-if="
                  $store.state.user.length > 0 &&
                  $store.state.user[0].profilepic
                "
              >
                <img :src="$store.state.user[0].profilepic" alt="e2m" />
              </v-avatar>
              <v-avatar
                size="36"
                color="grey"
                v-else
                style="text-transform: uppercase"
              >
                {{ getInitials() }}
              </v-avatar>
              <span class="pl-2">{{
                $store.state.user.length > 0 ? $store.state.user[0].fname : ""
              }}</span>
            </div>
          </v-list-item>
          <template v-for="(item, index) in menuItems">
            <v-list-item
              v-if="item.IsPublished"
              :key="index"
              @click="menuClicked(item)"
            >
              <v-list-item-title>{{ item.DisplayName }}</v-list-item-title>
            </v-list-item>
          </template>
          <v-list-item class="pa-0" style="min-height: 0">
            <v-list-item-content
              class="pa-0 pr-2"
              style="flex-direction: row-reverse; font-size: 10px"
            >
              {{ version }}
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>
    <v-navigation-drawer
      class="profile-nav-drawer"
      v-model="drawer"
      absolute
      bottom
      temporary
      width="350"
    >
      <div class="class-profile-wrap">
        <div class="class-image-wrap">
          <v-avatar
            color="#333"
            size="100"
            v-if="
              $store.state.user.length > 0 && $store.state.user[0].profilepic
            "
          >
            <v-img :src="$store.state.user[0].profilepic" alt="e2m" />
          </v-avatar>
          <v-avatar color="#333" size="100" v-else>
            <span class="white--text text-h2"> {{ getInitials() }}</span>
          </v-avatar>
          <!-- <span class="upload-class-profile-img">
            <v-icon dark color="#fff" size="18px">mdi-camera-plus</v-icon>
          </span> -->
        </div>
        <h4 class="class-bar-msg">Welcome</h4>
        <h3 class="class-bar-msg2">
          {{
            $store.state.user.length > 0
              ? $store.state.user[0].fname + " " + $store.state.user[0].lname
              : ""
          }}
        </h3>

        <v-chip
          class="ma-2"
          color="#3f4ba2"
          v-if="$store.state.user[0].userType != undefined"
          dark
        >
          {{
            $store.state.user[0].userType == "Attendee"
              ? isClientAdmin() == true
                ? "Admin"
                : "Student"
              : "Teacher"
          }}
        </v-chip>
      </div>
      <v-list nav dense>
        <v-list-item-group
          v-model="selectedItem"
          color="#4844d4"
          class="class-menu-list-wrap position-relative"
          style="cursor: pointer"
        >
          <template v-for="(item, index) in menuItems">
            <v-list-item
              v-if="item.IsPublished"
              :key="index"
              @click="menuClicked(item)"
            >
              <v-list-item-icon>
                <v-icon depressed size="35px">{{ item.IconName }}</v-icon>
              </v-list-item-icon>

              <v-list-item-content>
                <v-list-item-title>{{ item.DisplayName }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
          <template v-if="showResourceFeedbackMenu == true">
            <div class="resources-drop" style="width: 100%">
              <v-list>
                <v-list-group>
                  <template v-slot:activator>
                    <v-list-item-content>
                      <v-list-item-title>
                        <v-icon
                          style="margin-right: 18px"
                          depressed
                          color="#0000008a"
                          size="35px"
                          >mdi-semantic-web</v-icon
                        >
                        My Resources
                      </v-list-item-title>
                    </v-list-item-content>
                  </template>

                  <v-list-item v-if="showResourceFeedbackMenu == true">
                    <v-list-item-content class="ml-16 resource-drop-inner">
                      <v-list-item-title @click="menuClicked('Resources')">
                        <p class="m-0">
                          <v-icon
                            style="margin-right: 5px"
                            depressed
                            color="#0000008a"
                            size="35px"
                            >mdi-semantic-web</v-icon
                          >
                          Resource Library
                        </p>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                  <!-- <v-list-item>
                    <v-list-item-content class="ml-16 resource-drop-inner">
                      <v-list-item-title>
                        <p class="m-0">
                          <v-icon
                            style="margin-right: 14px"
                            depressed
                            color="#0000008a"
                            size="30px"
                            >mdi-text-box-multiple-outline</v-icon
                          >Exam Bank
                        </p>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item> -->
                  <!-- <v-list-item>
                    <v-list-item-content class="ml-16 resource-drop-inner">
                      <v-list-item-title>
                        <p class="m-0">
                          <v-icon
                            style="margin-right: 10px"
                            depressed
                            color="#0000008a"
                            size="30px"
                            >mdi-trophy-variant</v-icon
                          >
                          My Achievements
                        </p>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item> -->
                  <!-- <v-list-item v-if="showCertificatesMenu == true">
                    <v-list-item-content class="ml-16 resource-drop-inner">
                      <v-list-item-title
                        @click="menuClicked('My Certificates')"
                      >
                        <p class="m-0">
                          <v-icon
                            style="margin-right: 10px"
                            depressed
                            color="#0000008a"
                            size="30px"
                            >mdi-file-certificate</v-icon
                          >
                          My Certificates
                        </p>
                      </v-list-item-title>
                    </v-list-item-content>
                  </v-list-item> -->
                </v-list-group>
              </v-list>
            </div>
          </template>

          <div
            class="resources-drop feedback-drop position-relative"
            style="width: 100%"
            v-if="
              showSessionFeedbackMenu == true ||
              showCourseFeedbackMenu == true ||
              showSessionReportMenu == true
            "
          >
            <v-list>
              <v-list-group>
                <template v-slot:activator>
                  <v-list-item-content>
                    <v-list-item-title>
                      <v-icon
                        style="margin-right: 18px"
                        depressed
                        color="#0000008a"
                        size="35px"
                        >mdi-comment-quote</v-icon
                      >
                      Feedbacks
                    </v-list-item-title>
                  </v-list-item-content>
                </template>

                <v-list-item v-if="showSessionFeedbackMenu == true">
                  <v-list-item-content class="ml-16 resource-drop-inner">
                    <v-list-item-title
                      @click="menuClicked('Share Your Session Feedback')"
                    >
                      <p class="m-0">
                        <v-icon
                          style="margin-right: 18px"
                          depressed
                          color="#0000008a"
                          size="35px"
                          >mdi-comment-quote</v-icon
                        >
                        Session Feedback
                      </p>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="showCourseFeedbackMenu == true">
                  <v-list-item-content class="ml-16 resource-drop-inner">
                    <v-list-item-title @click="menuClicked('Courses Feedback')">
                      <p class="m-0">
                        <v-icon
                          style="margin-right: 10px"
                          depressed
                          color="#0000008a"
                          size="30px"
                          >mdi-comment-quote-outline</v-icon
                        >
                        Courses Feedback
                      </p>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>

                <v-list-item v-if="showSessionReportMenu == true">
                  <v-list-item-content class="ml-16 resource-drop-inner">
                    <v-list-item-title @click="menuClicked('Session Report')">
                      <p class="m-0">
                        <v-icon
                          style="margin-right: 10px"
                          depressed
                          color="#0000008a"
                          size="30px"
                          >mdi-file-chart</v-icon
                        >
                        Session Report
                      </p>
                    </v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list-group>
            </v-list>
          </div>
        </v-list-item-group>
      </v-list>
      <div class="side-panel-bottom sec">
        <div class="log-out-btn" @click="menuClicked('Log Out')">
          <p>
            <v-icon color="#0000008a" size="35px">mdi-logout</v-icon> Log Out
          </p>
        </div>
        <div class="class-product-version">
          <p>{{ version }}</p>
        </div>
      </div>
    </v-navigation-drawer>
    <div
      v-if="$vuetify.breakpoint.smAndUp"
      class="clientLobby"
      v-html="html"
    ></div>
    <div style="height: 100vh; display: flex; align-items: center" v-else>
      <v-alert type="info"
        ><div>
          <v-row justify="center">
            For best experience please join from a desktop or laptop / iPad
            device.
          </v-row>
          <v-row justify="center" class="pt-3 ml-n12">
            <v-btn
              @click="$router.push({ name: 'EventList' })"
              elevation="0"
              color="success"
              ><v-icon>chevron_left</v-icon> Go to events</v-btn
            >
          </v-row>
        </div></v-alert
      >
    </div>
    <v-dialog
      scrollable
      ref="clientLobby"
      :content-class="
        !$route.path.includes('profile')
          ? 'client-dialog'
          : 'client-dialog-profile'
      "
      transition="scroll-x-reverse-transition"
      v-model="dialog"
      width="auto"
    >
      <v-card style="min-height: 87vh; opacity: 0.97">
        <v-card-title
          ><div style="position: absolute; right: 10px; top: 10px; z-index: 7">
            <v-icon style="z-index: 2" size="32" @click="closeHandler()"
              >close</v-icon
            >
          </div></v-card-title
        >
        <v-card-text id="ClientLobbyCard" style="p-0;font-size:1rem">
          <div style="width: 100%; height: 100%">
            <router-view></router-view>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      width="1000px"
      v-model="profileView"
      transition="scroll-x-reverse-transition"
      persistent
    >
      <div
        style="
          height: 560px;
          width: 1000px;
          position: relative;
          overflow: hidden;
        "
      >
        <div
          class="
            dialog-profile-head
            d-flex
            justify-content-between
            align-items-center
          "
          style="background: #383f97; padding: 5px 10px"
        >
          <h2 style="color: #fff; font-weight: 500; margin: 0">
            {{ profileViewHeaderText }}
          </h2>
          <div>
            <v-icon
              style="z-index: 2"
              color="#fff"
              size="32"
              @click="closeHandler()"
              >close</v-icon
            >
          </div>
        </div>
        <iframe
          :src="profileViewUrl"
          height="100%"
          width="100%"
          frameborder="0"
          marginwidth="0"
          marginheight="0"
          allowfullscreen
        >
        </iframe>
      </div>
    </v-dialog>

    <v-dialog
      scrollable
      ref="clientLobby"
      :content-class="
        !$route.path.includes('profile')
          ? 'client-dialog reports-wrap'
          : 'client-dialog-profile reports-wrap'
      "
      transition="scroll-x-reverse-transition"
      v-model="reportDialog"
      width="auto"
      fullscreen="true"
    >
      <v-card style="min-height: 87vh; opacity: 1">
        <v-card-title
          ><v-btn
            style="position: absolute; left: 15px; top: 5px; z-index: 99"
            tile
            @click="closeHandler()"
            color="success"
          >
            <v-icon style="z-index: 2" size="32" class="mr-2"
              >mdi-arrow-left</v-icon
            >
            Back To Lobby
          </v-btn>
        </v-card-title>

        <v-card-text
          id="ClientLobbyCard"
          style="p-0;font-size:1rem;;margin: 0 !important"
        >
          <div style="width: 100%; height: 100%">
            <v-tabs vertical v-model="showSelectedTab">
              <div class="mt-12">
                <v-tab href="#overview" v-if="isClientAdmin() == true">
                  Dashboard
                </v-tab>
                <v-tab href="#attendance" v-if="isClientAdmin() == true">
                  Student Database
                </v-tab>

                <v-tab
                  v-show="
                    isClientAdmin() == false &&
                    $store.state.user[0].userType == 'Attendee'
                  "
                  href="#courseProgress"
                  @click="getStudentProgressByUserId()"
                >
                  Course Progress
                </v-tab>
                <v-tab
                  v-show="
                    isClientAdmin() == false &&
                    $store.state.user[0].userType == 'Speaker'
                  "
                  href="#courseProgress"
                >
                  Course Progress
                </v-tab>
                <v-tab v-show="isClientAdmin() == true" href="#courseProgress">
                  Course Progress
                </v-tab>
                <!-- <v-tab v-else> Course Progress1 </v-tab> -->

                <v-tab href="#dashboard" @click="selectedCourse = null">
                  Session Attendance
                </v-tab>
                <v-tab v-if="isClientAdmin() == true" href="#pos">
                  POS Reports
                </v-tab>
                <v-tab href="#monitoring" @click="selectedCourse = null">
                  Upcoming & Past Sessions
                </v-tab>
                <v-tab href="#performance" @click="selectedCourse = null">
                  Session Feedback Report
                </v-tab>

                <v-tab
                  href="#"
                  v-if="isClientAdmin() == true"
                  @click="goToJoinYourClass()"
                >
                  Class Monitoring
                </v-tab>
                <div class="side-panel-bottom sec">
                  <div class="log-out-btn" @click="menuClicked('Log Out')">
                    <p>
                      <v-icon color="#0000008a" size="35px">mdi-logout</v-icon>
                      Log Out
                    </p>
                  </div>
                  <div class="class-product-version">
                    <p>{{ version }}</p>
                  </div>
                </div>
              </div>

              <!-- <v-tab
                href="#teacherDetails"
                v-if="isClientAdmin() == true"
                @click="getAllTeacherDataByClient()"
              >
                Teacher Details Report
              </v-tab> -->
              <v-tab-item value="overview">
                <div class="reports-header">
                  <h2>Overview</h2>
                </div>

                <div class="overview-wrapper-main px-6">
                  <v-row>
                    <v-col md="3">
                      <div class="overview-box-wrap">
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                        >
                          <div>
                            <div class="overview-box-svg mb-6">
                              <span>
                                <img
                                  src="../assets/e2medu/icons/total-students.svg"
                                  height="50px"
                                  width="50px"
                                />
                              </span>
                            </div>

                            <h2>Total No. of Students</h2>
                            <h3 class="mt-2">
                              {{ totalStudentsCountForDashboard }}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col md="3">
                      <div class="overview-box-wrap">
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                        >
                          <div>
                            <div class="overview-box-svg mb-6">
                              <span>
                                <img
                                  src="../assets/e2medu/icons/active-students.svg"
                                  height="50px"
                                  width="50px"
                                />
                              </span>
                            </div>

                            <h2>No. of Active Students</h2>
                            <h3 class="mt-2">
                              {{ activeStudentsCountForDashboard }}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col md="3">
                      <div class="overview-box-wrap">
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                        >
                          <div>
                            <div class="overview-box-svg mb-6">
                              <span>
                                <img
                                  src="../assets/e2medu/icons/total-trial-class.svg"
                                  height="50px"
                                  width="50px"
                                />
                              </span>
                            </div>
                            <h2>Total Trial Classes</h2>
                            <h3 class="mt-2">
                              {{ totalTrialClassCountForDashboard }}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <v-col md="3">
                      <div class="overview-box-wrap">
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                        >
                          <div>
                            <div class="overview-box-svg mb-6">
                              <span>
                                <img
                                  src="../assets/e2medu/icons/teachers.svg"
                                  height="50px"
                                  width="50px"
                                />
                              </span>
                            </div>

                            <h2>No. of Teachers</h2>
                            <h3 class="mt-2">
                              {{ totalTeachersCountForDashboard }}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </v-col>

                    <v-col md="3">
                      <div class="overview-box-wrap">
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                          "
                        >
                          <div>
                            <div class="overview-box-svg mb-6">
                              <span>
                                <img
                                  src="../assets/e2medu/icons/classes-today.svg"
                                  height="50px"
                                  width="50px"
                                />
                              </span>
                            </div>

                            <h2>No. of Classes Today</h2>
                            <h3 class="mt-2">
                              {{ totalSessionsTodayCountForDashboard }}
                            </h3>
                          </div>
                        </div>
                      </div>
                    </v-col>
                    <!-- <v-col md="2">
                      <div class="overview-box-wrap">
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                            flex-column
                          "
                        >
                          <h3>15</h3>
                          <h2 class="overview-box-heading">No. of Teachers</h2>
                        </div>
                      </div>
                    </v-col>

                    <v-col md="2">
                      <div class="overview-box-wrap">
                        <div
                          class="
                            d-flex
                            justify-content-between
                            align-items-center
                            flex-column
                          "
                        >
                          <h3>3</h3>
                          <h2 class="overview-box-heading">
                            No. of Classes Today
                          </h2>
                        </div>
                      </div>
                    </v-col> -->
                  </v-row>
                </div>
              </v-tab-item>

              <v-tab-item value="attendance">
                <div class="reports-header">
                  <h2>Student Database</h2>

                  <div
                    class="download-reports-btn"
                    v-if="teacherData.length > 0 && selectedSubTabsSummary == 1"
                  >
                    <v-btn
                      v-if="selectedTeachers.length > 0"
                      small
                      color="green"
                      class="ml-2"
                      dark
                      depressed
                      @click="
                        downloadReports(selectedTeachers, 'TeacherDetails')
                      "
                    >
                      <v-icon color="#fff" class="mr-1"> mdi-download </v-icon>
                      Download
                    </v-btn>
                    <v-btn
                      v-else
                      small
                      color="green"
                      class="ml-2"
                      dark
                      depressed
                      @click="downloadReports(teacherData, 'TeacherDetails')"
                    >
                      <v-icon color="#fff" class="mr-1"> mdi-download </v-icon>
                      Download
                    </v-btn>
                  </div>

                  <div
                    class="download-reports-btn"
                    v-else-if="
                      filterStudentsData.length > 0 &&
                      selectedSubTabsSummary == 0
                    "
                  >
                    <v-btn
                      v-if="selectedStudents.length > 0"
                      small
                      color="green"
                      class="ml-2"
                      dark
                      depressed
                      @click="
                        downloadReports(selectedStudents, 'StudentDetails')
                      "
                    >
                      <v-icon color="#fff" class="mr-1"> mdi-download </v-icon>
                      Download
                    </v-btn>
                    <v-btn
                      v-else
                      small
                      color="green"
                      class="ml-2"
                      dark
                      depressed
                      @click="
                        downloadReports(filterStudentsData, 'StudentDetails')
                      "
                    >
                      <v-icon color="#fff" class="mr-1"> mdi-download </v-icon>
                      Download
                    </v-btn>
                  </div>
                </div>

                <v-tabs
                  v-model="selectedSubTabsSummary"
                  class="position-relative"
                >
                  <v-tab @click="getStudentList('Active')">
                    Classes Remaining</v-tab
                  >

                  <v-tab @click="getStudentList('Past')">
                    Classes Completed</v-tab
                  >
                  <!-- <v-tab @click="getAllTeacherDataByClient()">
                    All Teacher List
                  </v-tab> -->

                  <v-tab-item>
                    <div class="d-flex justify-content-end align-items-center">
                      <!-- <div
                        class="
                          d-inline-flex
                          justify-content-center
                          align-items-center
                          mt-2
                          mr-2
                        "
                      >
                        <v-select
                          :items="studentsFilter"
                          label="Filter"
                          outlined
                          dense
                          height="45px"
                          v-model="selectedStudentFilter"
                        ></v-select>
                      </div> -->

                      <div
                        class="
                          d-inline-flex
                          justify-content-center
                          align-items-center
                          auto-search-for-table
                        "
                      >
                        <v-text-field
                          class="pt-0 mt-0"
                          v-model="search"
                          prepend-inner-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                      </div>
                    </div>

                    <div class="report-table">
                      <v-data-table
                        style="width: 100%"
                        :loading="tableLoader"
                        :headers="allStudentTableHeaderData"
                        :items-per-page="50"
                        show-select
                        :items="filterStudentsData"
                        :search="search"
                        height="315px"
                        fixed-header
                        :single-select="singleSelect"
                        class="elevation-1"
                        item-key="id"
                        v-model="selectedStudents"
                        @click:row="handleClick"
                      >
                        <template v-slot:item.details="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                @click="showUserSelectedCourse(item)"
                              >
                                mdi-eye
                              </v-icon>
                            </template>
                            <span> View Details </span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </div>
                  </v-tab-item>

                  <v-tab-item>
                    <div class="d-flex justify-content-end align-items-center">
                      <!-- <div
                        class="
                          d-inline-flex
                          justify-content-center
                          align-items-center
                          mt-2
                          mr-2
                        "
                      >
                        <v-select
                          :items="studentsFilter"
                          label="Filter"
                          outlined
                          dense
                          height="45px"
                          v-model="selectedStudentFilter"
                        ></v-select>
                      </div> -->
                      <div
                        class="
                          d-inline-flex
                          justify-content-center
                          align-items-center
                          auto-search-for-table
                        "
                      >
                        <v-text-field
                          class="pt-0 mt-0"
                          v-model="search"
                          prepend-inner-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                      </div>
                    </div>

                    <div class="report-table">
                      <v-data-table
                        style="width: 100%"
                        :loading="tableLoader"
                        :headers="allStudentTableHeaderData"
                        :items-per-page="50"
                        show-select
                        :items="filterStudentsData"
                        :search="search"
                        height="315px"
                        fixed-header
                        :single-select="singleSelect"
                        class="elevation-1"
                        item-key="id"
                        v-model="selectedStudents"
                        @click:row="handleClick"
                      >
                        <template v-slot:item.details="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                @click="showUserSelectedCourse(item)"
                              >
                                mdi-eye
                              </v-icon>
                            </template>
                            <span> View Details </span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </div>
                  </v-tab-item>

                  <v-tab-item>
                    <div class="d-flex justify-content-end align-items-center">
                      <div
                        class="
                          d-inline-flex
                          justify-content-center
                          align-items-center
                          auto-search-for-table
                        "
                      >
                        <v-text-field
                          class="pt-0 mt-0"
                          v-model="searchTeacher"
                          prepend-inner-icon="mdi-magnify"
                          label="Search"
                          single-line
                          hide-details
                        ></v-text-field>
                      </div>
                    </div>
                    <div class="report-table">
                      <v-data-table
                        style="width: 100%"
                        v-model="selectedTeachers"
                        :loading="teacherDetailsLoaded"
                        :headers="teacherTableHeaderData"
                        :items-per-page="50"
                        :items="teacherData"
                        :search="searchTeacher"
                        height="315px"
                        fixed-header
                        item-key="id"
                        class="elevation-1"
                        :single-select="singleSelect"
                        show-select
                        @click:row="handleClick"
                      >
                        <template v-slot:item.details="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                @click="showUserSelectedCourse(item)"
                              >
                                mdi-eye
                              </v-icon>
                            </template>
                            <span> View Details </span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </div>
                  </v-tab-item>
                </v-tabs>
              </v-tab-item>

              <v-tab-item value="courseProgress">
                <div class="reports-header">
                  <h2>Course Progress</h2>

                  <div
                    v-show="
                      isClientAdmin() == false &&
                      $store.state.user[0].userType == 'Attendee'
                    "
                  >
                    <h5>For Student</h5>
                  </div>
                  <div
                    v-show="
                      isClientAdmin() == false &&
                      $store.state.user[0].userType == 'Speaker'
                    "
                  >
                    <div
                      class="
                        common-course-search
                        d-flex
                        justify-content-between
                        align-items-center
                        mb-3
                      "
                    >
                      <div
                        class="d-flex justify-content-start align-items-center"
                      >
                        <div
                          class="
                            drop-tipe
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                        >
                          <v-autocomplete
                            :items="allCourseList"
                            prepend-inner-icon="search"
                            clearable
                            return-object
                            hide-details
                            :item-text="'EventFullName'"
                            :item-value="'EventId'"
                            v-model="selectedCourse"
                            placeholder="Select Course"
                            dense
                            outlined
                            @change="
                              getCourseSpecificAttendance(selectedCourse)
                            "
                            :loading="loadCourse"
                          >
                          </v-autocomplete>
                        </div>
                        <div
                          class="
                            double-dropdown-course
                            d-flex
                            justify-content-center
                            align-items-center
                            ml-3
                          "
                          v-if="true"
                        >
                          <v-autocomplete
                            :items="allUsersListOfClient"
                            prepend-inner-icon="search"
                            clearable
                            :item-text="'user_name'"
                            :item-value="'user_id'"
                            v-model="selectedUser"
                            placeholder="Select User"
                            dense
                            outlined
                            @change="getstudentsDataByCourseId(selectedUser)"
                            :loading="loadUser"
                          >
                          </v-autocomplete>
                        </div>
                      </div>
                      <v-btn
                        small
                        v-if="selectedCourse != null"
                        color="blue"
                        class="ml-2"
                        @click="getSessionsByEventId(selectedCourse)"
                        outlined
                      >
                        <v-icon color="#1976d" class="mr-1">
                          mdi-refresh-circle
                        </v-icon>
                        Reload
                      </v-btn>
                    </div>
                  </div>
                  <div v-show="isClientAdmin() == true">
                    <div
                      class="
                        common-course-search
                        d-flex
                        justify-content-between
                        align-items-center
                        mb-3
                      "
                    >
                      <div
                        class="d-flex justify-content-start align-items-center"
                      >
                        <div
                          class="
                            drop-tipe
                            d-flex
                            justify-content-center
                            align-items-center
                          "
                        >
                          <v-autocomplete
                            :items="allCourseList"
                            prepend-inner-icon="search"
                            clearable
                            return-object
                            hide-details
                            :item-text="'EventFullName'"
                            :item-value="'EventId'"
                            v-model="selectedCourseProgress"
                            placeholder="Select Course"
                            dense
                            outlined
                            @change="
                              getCourseSpecificAttendance(
                                selectedCourseProgress
                              )
                            "
                            :loading="loadCourse"
                          >
                          </v-autocomplete>
                        </div>
                        <div
                          class="
                            double-dropdown-course
                            d-flex
                            justify-content-center
                            align-items-center
                            ml-3
                          "
                        >
                          <v-autocomplete
                            v-if="selectedCourseProgress != null"
                            :items="filterAllStudentsByCourseId"
                            prepend-inner-icon="search"
                            clearable
                            :item-text="'user_name'"
                            :item-value="'user_id'"
                            v-model="selectedUser"
                            placeholder="Select User"
                            dense
                            outlined
                            @change="getstudentsDataByCourseId(selectedUser)"
                            :loading="loadUser"
                          >
                          </v-autocomplete>
                        </div>
                      </div>
                      <v-btn
                        small
                        v-if="selectedCourseProgress != null"
                        color="blue"
                        class="ml-2"
                        @click="getSessionsByEventId(selectedCourse)"
                        outlined
                      >
                        <v-icon color="#1976d" class="mr-1">
                          mdi-refresh-circle
                        </v-icon>
                        Reload
                      </v-btn>
                    </div>

                    <div
                      class="report-table"
                      v-if="selectedCourseProgress != null"
                    >
                      <v-data-table
                        style="width: 100%"
                        :loading="tableLoader"
                        :headers="courseProgressHeaders"
                        :items-per-page="50"
                        show-select
                        :items="courseProgressData"
                        :search="search"
                        height="315px"
                        fixed-header
                        :single-select="singleSelect"
                        class="elevation-1"
                        item-key="id"
                        v-model="selectedStudents"
                        @click:row="handleClick"
                      >
                        <template v-slot:item.details="{ item }">
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon
                                v-bind="attrs"
                                v-on="on"
                                @click="showUserSelectedCourse(item)"
                              >
                                mdi-eye
                              </v-icon>
                            </template>
                            <span> View Details </span>
                          </v-tooltip>
                        </template>
                      </v-data-table>
                    </div>
                  </div>

                  <!-- <div
                    class="download-reports-btn"
                    v-if="teacherData.length > 0 && selectedSubTabsSummary == 1"
                  >
                    <v-btn
                      v-if="selectedTeachers.length > 0"
                      small
                      color="green"
                      class="ml-2"
                      dark
                      depressed
                      @click="
                        downloadReports(selectedTeachers, 'TeacherDetails')
                      "
                    >
                      <v-icon color="#fff" class="mr-1"> mdi-download </v-icon>
                      Download
                    </v-btn>
                    <v-btn
                      v-else
                      small
                      color="green"
                      class="ml-2"
                      dark
                      depressed
                      @click="downloadReports(teacherData, 'TeacherDetails')"
                    >
                      <v-icon color="#fff" class="mr-1"> mdi-download </v-icon>
                      Download
                    </v-btn>
                  </div>

                  <div
                    class="download-reports-btn"
                    v-else-if="
                      filterStudentsData.length > 0 &&
                      selectedSubTabsSummary == 0
                    "
                  >
                    <v-btn
                      v-if="selectedStudents.length > 0"
                      small
                      color="green"
                      class="ml-2"
                      dark
                      depressed
                      @click="
                        downloadReports(selectedStudents, 'StudentDetails')
                      "
                    >
                      <v-icon color="#fff" class="mr-1"> mdi-download </v-icon>
                      Download
                    </v-btn>
                    <v-btn
                      v-else
                      small
                      color="green"
                      class="ml-2"
                      dark
                      depressed
                      @click="
                        downloadReports(filterStudentsData, 'StudentDetails')
                      "
                    >
                      <v-icon color="#fff" class="mr-1"> mdi-download </v-icon>
                      Download
                    </v-btn>
                  </div> -->
                </div>
              </v-tab-item>

              <v-tab-item value="dashboard">
                <div
                  class="
                    reports-header
                    d-flex
                    justify-content-between
                    align-items-center
                  "
                >
                  <h2>Session Attendance</h2>
                </div>
                <div class="report-toolbar">
                  <div
                    class="
                      drop-tipe
                      d-flex
                      justify-content-center
                      align-items-center
                    "
                  >
                    <v-autocomplete
                      v-if="allCourseList"
                      :items="allCourseList"
                      prepend-inner-icon="search"
                      clearable
                      return-object
                      hide-details
                      :item-text="'EventFullName'"
                      :item-value="'EventId'"
                      v-model="selectedCourse"
                      placeholder="Select Course"
                      dense
                      outlined
                      @change="getstudentsDataByCourseId(selectedCourse)"
                      :loading="loadCourse"
                    >
                    </v-autocomplete>
                  </div>
                  <v-btn
                    small
                    v-if="selectedCourse != null"
                    color="blue"
                    class="ml-2"
                    @click="getstudentsDataByCourseId(selectedCourse)"
                    outlined
                  >
                    <v-icon color="#1976d2" class="mr-1">
                      mdi-refresh-circle
                    </v-icon>
                    Reload
                  </v-btn>
                  <div
                    class="report-search d-none"
                    v-if="selectedCourse != null"
                  >
                    <v-icon depressed color="#8a8a8a" size="25"
                      >mdi-magnify</v-icon
                    >
                    <input
                      type="text"
                      class="search-input"
                      id=""
                      value=""
                      placeholder="search courses..."
                    />
                  </div>
                </div>

                <div class="report-table-no-data" v-if="selectedCourse == null">
                  <v-icon depressed color="#8a8a8a" size="80"
                    >mdi-view-dashboard-outline</v-icon
                  >
                  <p>Please select a course to view report</p>
                </div>

                <div
                  class="report-table mx-5 mt-3"
                  v-if="selectedCourse != null"
                >
                  <v-data-table
                    :headers="headers"
                    :items="students"
                    item-key="name"
                    v-model="selected2"
                    fixed-header
                    height="355px"
                    :items-per-page="20"
                    :loading="loadDashboardData"
                    loading-text="Please wait, Data is loading.."
                  >
                    <template
                      v-for="(slot, i) in headers"
                      v-slot:[`item.${slot.value}`]="{ item }"
                    >
                      <div :key="i" v-if="i == 0">
                        {{ item[slot.value] }}
                      </div>
                      <div :key="i" v-else>
                        <v-tooltip
                          bottom
                          v-if="item[slot.value] == 'XMapped'"
                          color="white"
                          close-delay="500"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="#bebebe"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="
                                getSessionDetailsBySessionId(
                                  headers[i].value,
                                  item.Email
                                )
                              "
                            >
                              mdi-minus-circle-outline
                            </v-icon>
                          </template>
                          <div class="session-status">
                            <span>Not Mapped</span>
                            <p v-if="sessionDetailTooltip">Session Time:</p>
                            <div
                              class="session-date-time"
                              v-if="sessionDetailTooltip"
                            >
                              <p>{{ sessionDetailTooltip }}</p>
                              <!-- <a
                                href="javascript(0):void"
                                @click="openRescheduleDialog(item)"
                                >Reschedule<v-icon color="blue">
                                  mdi-chevron-right</v-icon
                                ></a
                              > -->
                            </div>
                          </div>
                          <!-- <span>
                            Not Mapped <br /><span v-if="sessionDetailTooltip"
                              >Session:({{ sessionDetailTooltip }})</span
                            ></span
                          > -->
                        </v-tooltip>
                        <v-tooltip
                          bottom
                          v-if="item[slot.value] == 'XAttended'"
                          color="white"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="#2f9d12"
                              v-bind="attrs"
                              v-on="on"
                              @click="
                                isClientAdmin() == true
                                  ? openRescheduleDialog(headers[i].value)
                                  : ''
                              "
                              @mouseover="
                                getSessionDetailsBySessionId(
                                  headers[i].value,
                                  item.Email
                                )
                              "
                            >
                              mdi-timer-sand
                            </v-icon>
                          </template>
                          <div class="session-status">
                            <span>Session live. Yet to join</span>
                            <p v-if="sessionDetailTooltip">Session Time:</p>
                            <div
                              class="session-date-time"
                              v-if="sessionDetailTooltip"
                            >
                              <p>{{ sessionDetailTooltip }}</p>
                            </div>
                          </div>
                        </v-tooltip>

                        <v-tooltip
                          bottom
                          v-else-if="item[slot.value] == 'Missed'"
                          color="white"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="#f00"
                              v-bind="attrs"
                              v-on="on"
                              @click="
                                isClientAdmin() == true
                                  ? openRescheduleDialog(headers[i].value)
                                  : ''
                              "
                              @mouseover="
                                getSessionDetailsBySessionId(
                                  headers[i].value,
                                  item.Email
                                )
                              "
                            >
                              mdi-alert-circle-outline
                            </v-icon>
                          </template>
                          <div class="session-status">
                            <span>Missed</span>
                            <p v-if="sessionDetailTooltip">Session Time:</p>
                            <div
                              class="session-date-time"
                              v-if="sessionDetailTooltip"
                            >
                              <p>{{ sessionDetailTooltip }}</p>
                              <a
                                v-if="isClientAdmin() == true"
                                href="javascript(0):void"
                                @click="openRescheduleDialog(headers[i].value)"
                                >Reschedule<v-icon color="blue">
                                  mdi-chevron-right</v-icon
                                ></a
                              >
                            </div>
                          </div>
                        </v-tooltip>

                        <v-tooltip
                          bottom
                          v-else-if="item[slot.value] == 'Attended'"
                          color="white"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="#2f9d12"
                              v-bind="attrs"
                              v-on="on"
                              @mouseover="
                                getSessionDetailsBySessionId(
                                  headers[i].value,
                                  item.Email
                                )
                              "
                            >
                              mdi-check-circle-outline
                            </v-icon>
                          </template>
                          <div class="session-status">
                            <span>Attended</span>
                            <p v-if="sessionDetailTooltip">Session Time:</p>
                            <div
                              class="session-date-time"
                              v-if="sessionDetailTooltip"
                            >
                              <p>{{ sessionDetailTooltip }}</p>
                              <!-- <a
                                href="javascript(0):void"
                                @click="openRescheduleDialog(item)"
                                >Reschedule<v-icon color="blue">
                                  mdi-chevron-right</v-icon
                                ></a
                              > -->
                            </div>
                          </div>
                        </v-tooltip>

                        <v-tooltip
                          bottom
                          v-else-if="item[slot.value] == 'Upcoming'"
                          color="white"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon
                              color="#ffa531"
                              v-bind="attrs"
                              v-on="on"
                              @click="
                                isClientAdmin() == true
                                  ? openRescheduleDialog(headers[i].value)
                                  : ''
                              "
                              @mouseover="
                                getSessionDetailsBySessionId(
                                  headers[i].value,
                                  item.Email
                                )
                              "
                            >
                              mdi-calendar-end
                            </v-icon>
                          </template>
                          <div class="session-status">
                            <span>Upcoming</span>
                            <p v-if="sessionDetailTooltip">Session Time:</p>
                            <div
                              class="session-date-time"
                              v-if="sessionDetailTooltip"
                            >
                              <p>{{ sessionDetailTooltip }}</p>
                              <a
                                v-if="isClientAdmin() == true"
                                href="javascript(0):void"
                                @click="openRescheduleDialog(headers[i].value)"
                                >Reschedule<v-icon color="blue">
                                  mdi-chevron-right</v-icon
                                ></a
                              >
                            </div>
                          </div>
                        </v-tooltip>
                      </div>
                    </template>
                  </v-data-table>
                </div>
              </v-tab-item>
              <v-tab-item v-if="isClientAdmin() == true" value="pos">
                <div
                  class="
                    reports-header
                    d-flex
                    justify-content-between
                    align-items-center
                  "
                >
                  <h2>POS Reports</h2>
                </div>
                <ul class="pos-wrapper">
                  <li class="pos-list-items">
                    <v-icon color="#fff" size="45">
                      mdi-clipboard-account-outline
                    </v-icon>
                    <p>User Report</p>
                    <v-btn
                      small
                      color="#353c94"
                      dark
                      class="mt-3"
                      @click="getPosReports('User Report')"
                    >
                      <v-icon color="#fff" class="mr-1"> mdi-download </v-icon>
                      Download
                    </v-btn>
                  </li>
                  <li class="pos-list-items">
                    <v-icon color="#fff" size="45">
                      mdi-chart-areaspline
                    </v-icon>
                    <p>Trial Report</p>
                    <v-btn
                      small
                      color="#353c94"
                      dark
                      class="mt-3"
                      @click="getPosReports('Trial Report')"
                    >
                      <v-icon color="#fff" class="mr-1"> mdi-download </v-icon>
                      Download
                    </v-btn>
                  </li>
                  <li class="pos-list-items">
                    <v-icon color="#fff" size="45">
                      mdi-file-chart-outline
                    </v-icon>
                    <p>Order Report</p>
                    <v-btn
                      small
                      color="#353c94"
                      dark
                      class="mt-3"
                      @click="getPosReports('Order Report')"
                    >
                      <v-icon color="#fff" class="mr-1"> mdi-download </v-icon>
                      Download
                    </v-btn>
                  </li>
                  <li class="pos-list-items">
                    <v-icon color="#fff" size="45"> mdi-check-outline </v-icon>
                    <p style="text-align: center">Course Completion Report</p>

                    <v-btn
                      small
                      color="#353c94"
                      dark
                      class="mt-3"
                      @click="getPosReports('Course Completion Report')"
                    >
                      <v-icon color="#fff" class="mr-1"> mdi-download </v-icon>
                      Download
                    </v-btn>
                  </li>
                </ul>
              </v-tab-item>
              <v-tab-item>
                <p>Reports</p>
              </v-tab-item>
              <v-tab-item value="monitoring">
                <div class="reports-header">
                  <h2>Upcoming & Past Sessions</h2>
                  <div
                    class="download-reports-btn"
                    v-if="
                      sessionData.length > 0 &&
                      selectedSubSessionTabsSummary == 0
                    "
                  >
                    <v-btn
                      v-if="selectedUpcomingSessions.length > 0"
                      small
                      color="green"
                      class="ml-2"
                      dark
                      depressed
                      @click="
                        downloadReports(
                          selectedUpcomingSessions,
                          'UpcomingSessionDetails'
                        )
                      "
                    >
                      <v-icon color="#fff" class="mr-1"> mdi-download </v-icon>
                      Download
                    </v-btn>
                    <v-btn
                      v-else
                      small
                      color="green"
                      class="ml-2"
                      dark
                      depressed
                      @click="
                        downloadReports(sessionData, 'UpcomingSessionDetails')
                      "
                    >
                      <v-icon color="#fff" class="mr-1"> mdi-download </v-icon>
                      Download
                    </v-btn>
                  </div>
                  <div
                    class="download-reports-btn"
                    v-if="
                      sessionData.length > 0 &&
                      selectedSubSessionTabsSummary == 1
                    "
                  >
                    <v-btn
                      v-if="selectedPastSessions.length > 0"
                      small
                      color="green"
                      class="ml-2"
                      dark
                      depressed
                      @click="
                        downloadReports(
                          selectedPastSessions,
                          'PastSessionDetails'
                        )
                      "
                    >
                      <v-icon color="#fff" class="mr-1"> mdi-download </v-icon>
                      Download
                    </v-btn>
                    <v-btn
                      v-else
                      small
                      color="green"
                      class="ml-2"
                      dark
                      depressed
                      @click="
                        downloadReports(sessionData, 'PastSessionDetails')
                      "
                    >
                      <v-icon color="#fff" class="mr-1"> mdi-download </v-icon>
                      Download
                    </v-btn>
                  </div>
                </div>
                <div
                  class="
                    common-course-search
                    d-flex
                    justify-content-between
                    align-items-center
                    mb-3
                  "
                >
                  <div class="d-flex justify-content-start align-items-center">
                    <div
                      class="
                        drop-tipe
                        d-flex
                        justify-content-center
                        align-items-center
                      "
                    >
                      <v-autocomplete
                        v-if="allCourseList"
                        :items="allCourseList"
                        prepend-inner-icon="search"
                        clearable
                        return-object
                        hide-details
                        :item-text="'EventFullName'"
                        :item-value="'EventId'"
                        v-model="selectedCourse"
                        placeholder="Select Course"
                        dense
                        outlined
                        @change="getSessionsByEventId(selectedCourse)"
                        :loading="loadCourse"
                      >
                      </v-autocomplete>
                    </div>
                    <div
                      class="
                        double-dropdown-course
                        d-flex
                        justify-content-center
                        align-items-center
                        ml-3
                      "
                    >
                      <v-autocomplete
                        v-if="allUsersListOfClient"
                        :items="allUsersListOfClient"
                        prepend-inner-icon="search"
                        clearable
                        :item-text="'user_name'"
                        :item-value="'user_id'"
                        v-model="selectedUser"
                        placeholder="Select User"
                        dense
                        outlined
                        @change="getstudentsDataByCourseId(selectedUser)"
                        :loading="loadUser"
                      >
                      </v-autocomplete>
                    </div>
                  </div>
                  <v-btn
                    small
                    v-if="selectedCourse != null"
                    color="blue"
                    class="ml-2"
                    @click="getSessionsByEventId(selectedCourse)"
                    outlined
                  >
                    <v-icon color="#1976d" class="mr-1">
                      mdi-refresh-circle
                    </v-icon>
                    Reload
                  </v-btn>
                </div>
                <div class="session-table-tab-wrap">
                  <div
                    class="report-table-no-data"
                    v-if="selectedCourse == null"
                  >
                    <v-icon depressed color="#8a8a8a" size="80"
                      >mdi-eye-check-outline</v-icon
                    >
                    <p>Please select a course to view report</p>
                  </div>

                  <v-tabs
                    v-if="selectedCourse != null"
                    v-model="selectedSubSessionTabsSummary"
                  >
                    <v-tab @click="getUpcomingSessions()">
                      Upcoming Sessions
                    </v-tab>
                    <v-tab @click="getPreSessions"> Past Sessions </v-tab>
                    <v-tab-item>
                      <div class="report-table">
                        <v-data-table
                          style="width: 100%"
                          :loading="tableLoader"
                          :headers="classMonitoringHeaders"
                          height="315px"
                          :items-per-page="50"
                          :items="sessionData"
                          fixed-header
                          item-key="sessionName"
                          class="elevation-1"
                          v-model="selectedUpcomingSessions"
                          :single-select="singleSelect"
                          show-select
                          @click:row="handleClick"
                        >
                          <template v-slot:item.reschedule="{ item }">
                            <v-tooltip bottom v-if="isClientAdmin() == true">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  color="#ffa531"
                                  @click="openRescheduleDialog(item.sessionId)"
                                >
                                  mdi-calendar-end
                                </v-icon>
                              </template>
                              <span> Reschedule </span>
                            </v-tooltip>
                          </template>
                        </v-data-table>
                      </div>
                    </v-tab-item>
                    <v-tab-item>
                      <div class="report-table">
                        <v-data-table
                          style="width: 100%"
                          :loading="tableLoader"
                          :headers="classMonitoringHeaders"
                          height="315px"
                          :items-per-page="50"
                          :items="sessionData"
                          fixed-header
                          item-key="id"
                          class="elevation-1"
                          v-model="selectedPastSessions"
                          :single-select="singleSelect"
                          show-select
                          @click:row="handleClick"
                        >
                          <template v-slot:item.reschedule="{ item }">
                            <v-tooltip
                              bottom
                              v-if="
                                item.total_duration == 0 &&
                                isClientAdmin() == true
                              "
                            >
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  v-bind="attrs"
                                  v-on="on"
                                  color="#ffa531"
                                  @click="openRescheduleDialog(item.sessionId)"
                                >
                                  mdi-calendar-end
                                </v-icon>
                              </template>
                              <span> Reschedule </span>
                            </v-tooltip>
                          </template>
                        </v-data-table>
                      </div>
                    </v-tab-item>
                  </v-tabs>
                </div>
              </v-tab-item>

              <v-tab-item value="performance">
                <div class="reports-header">
                  <h2>Session Feedback Report</h2>
                </div>
                <div
                  class="
                    common-course-search
                    d-flex
                    justify-content-between
                    align-items-center
                    mb-3
                  "
                >
                  <div
                    class="
                      drop-tipe
                      d-flex
                      justify-content-center
                      align-items-center
                    "
                  >
                    <v-autocomplete
                      v-if="allCourseList"
                      :items="allCourseList"
                      prepend-inner-icon="search"
                      clearable
                      return-object
                      hide-details
                      :item-text="'EventFullName'"
                      :item-value="'EventId'"
                      v-model="selectedCourse"
                      placeholder="Select Course"
                      dense
                      outlined
                      @change="
                        getClassPerformanceDataByCourseId(selectedCourse)
                      "
                      :loading="loadCourse"
                    >
                    </v-autocomplete>
                  </div>

                  <v-btn
                    small
                    v-if="selectedCourse != null"
                    color="blue"
                    class="ml-2"
                    @click="getClassPerformanceDataByCourseId(selectedCourse)"
                    outlined
                  >
                    <v-icon color="#1976d" class="mr-1">
                      mdi-refresh-circle
                    </v-icon>
                    Reload
                  </v-btn>
                </div>
                <div class="session-table-tab-wrap">
                  <div
                    class="report-table-no-data"
                    v-if="selectedCourse == null"
                  >
                    <v-icon depressed color="#8a8a8a" size="80"
                      >mdi-eye-check-outline</v-icon
                    >
                    <p>Please select a course to view report</p>
                  </div>
                  <v-tabs v-if="selectedCourse != null">
                    <v-tab @click="getStudentsFeedbackData()">
                      Student Feedback
                    </v-tab>
                    <v-tab @click="getTeachersFeedbackData()">
                      Teacher Feedback
                    </v-tab>
                    <v-tab @click="progressReport()"> Session Report </v-tab>

                    <v-tab-item>
                      <div class="report-table">
                        <v-data-table
                          style="width: 100%"
                          :loading="tableLoader"
                          :headers="feedbackTableHeaderData"
                          :items-per-page="20"
                          :items="studentFeedbackData"
                          height="315px"
                          fixed-header
                          item-key="name"
                          class="elevation-1"
                        >
                          <template v-slot:item.feedback="{ item }">
                            <v-tooltip bottom v-if="item.feedback != null">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="#2f9d12"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="
                                    showRatingFeedback(
                                      item.sessionName,
                                      item.feedback
                                    )
                                  "
                                >
                                  mdi-check-circle-outline
                                </v-icon>
                              </template>
                              <span> Feedback Given </span>
                            </v-tooltip>

                            <v-tooltip bottom v-else>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="#ffa531"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-comment-alert-outline
                                </v-icon>
                              </template>
                              <span> Feedback Not Given</span>
                            </v-tooltip>
                          </template>
                        </v-data-table>
                      </div>
                    </v-tab-item>
                    <v-tab-item>
                      <div class="report-table">
                        <v-data-table
                          style="width: 100%"
                          :loading="tableLoader"
                          :headers="feedbackTableHeaderData"
                          :items-per-page="20"
                          :items="teacherFeedbackData"
                          height="315px"
                          fixed-header
                          item-key="name"
                          class="elevation-1"
                        >
                          <template v-slot:item.feedback="{ item }">
                            <v-tooltip bottom v-if="item.feedback != null">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="#2f9d12"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="
                                    showRatingFeedback(
                                      item.sessionName,
                                      item.feedback
                                    )
                                  "
                                >
                                  mdi-check-circle-outline
                                </v-icon>
                              </template>
                              <span> Feedback Given </span>
                            </v-tooltip>

                            <v-tooltip bottom v-else>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="#ffa531"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-comment-alert-outline
                                </v-icon>
                              </template>
                              <span> Feedback Not Given</span>
                            </v-tooltip>
                          </template>
                        </v-data-table>
                      </div>
                    </v-tab-item>
                    <v-tab-item>
                      <div class="report-table">
                        <v-data-table
                          style="width: 100%"
                          :loading="tableLoader"
                          :headers="progressReportsHeaders"
                          :items-per-page="20"
                          :items="progressReports"
                          height="315px"
                          fixed-header
                          item-key="name"
                          class="elevation-1"
                        >
                          <template v-slot:item.reviewed="{ item }">
                            <v-tooltip bottom v-if="item.feedback != null">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="#2f9d12"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-check-circle-outline
                                </v-icon>
                              </template>
                              <span> Feedback Given </span>
                            </v-tooltip>

                            <v-tooltip bottom v-else>
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  color="#ffa531"
                                  v-bind="attrs"
                                  v-on="on"
                                >
                                  mdi-comment-alert-outline
                                </v-icon>
                              </template>
                              <span> Feedback Not Given</span>
                            </v-tooltip>
                          </template>

                          <template v-slot:item.feedback="{ item }">
                            <v-tooltip bottom v-if="item.feedback != null">
                              <template v-slot:activator="{ on, attrs }">
                                <v-icon
                                  style="cursor: pointer"
                                  v-bind="attrs"
                                  v-on="on"
                                  @click="openFeedbackDialog(item.feedback)"
                                >
                                  mdi-eye
                                </v-icon>
                              </template>
                              <span> View Feedback</span>
                            </v-tooltip>
                          </template>
                        </v-data-table>
                      </div>
                    </v-tab-item>
                  </v-tabs>
                </div>
              </v-tab-item>
              <v-tab-item value="teacherDetails">
                <div class="reports-header">
                  <h2>Teacher Details Report</h2>

                  <!-- <div
                    class="download-reports-btn"
                    v-if="teacherData.length > 0"
                  >
                    <v-btn
                      small
                      color="green"
                      class="ml-2"
                      dark
                      depressed
                      @click="downloadReports(teacherData, 'TeacherDetails')"
                    >
                      <v-icon color="#fff" class="mr-1"> mdi-download </v-icon>
                      Download
                    </v-btn>
                  </div> -->
                </div>

                <div class="session-table-tab-wrap">
                  <div class="report-table">
                    <v-data-table
                      style="width: 100%"
                      :loading="teacherDetailsLoaded"
                      :headers="teacherTableHeaderData"
                      :items-per-page="25"
                      :items="teacherData"
                      height="380px"
                      fixed-header
                      item-key="name"
                      class="elevation-1"
                    ></v-data-table>
                  </div>
                </div>
              </v-tab-item>
            </v-tabs>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog v-model="feedbackDialog" class="chat-dialog" width="800">
      <v-card>
        <v-card-actions class="d-flex justify-content-end">
          <h3 style="margin-right: 70%">SESSION REPORT</h3>
          <div class="close-action">
            <v-icon dark size="20" color="#333" @click="feedbackDialog = false"
              >mdi-close</v-icon
            >
          </div>
        </v-card-actions>
        <div v-html="feedbackHtml"></div>
      </v-card>
    </v-dialog>

    <v-dialog
      scrollable
      content-class="client-dialog resource-dialog"
      transition="scroll-x-reverse-transition"
      v-model="resourceDialog"
      width="auto"
    >
      <v-card style="min-height: 87vh; opacity: 0.97">
        <v-card-title>
          <div
            class="
              resource-head
              p-4
              d-flex
              justify-content-between
              align-items-center
            "
            style="width: 100%"
          >
            <h3 class="m-0">Resources</h3>
            <div style="">
              <v-icon style="z-index: 2" size="32" @click="closeHandler()"
                >close</v-icon
              >
            </div>
          </div></v-card-title
        >
        <v-card-text id="ClientLobbyCard" style="p-0;font-size:1rem">
          <div class="resource-tab-area" style="width: 100%; height: 100%">
            <!-- <router-view></router-view> -->
            <v-tabs vertical>
              <!-- <h2>My EduLife</h2> -->

              <v-tab class="top-dast"> Resource Library </v-tab>
              <!-- <v-tab>
                My courses
              </v-tab>
              <v-tab class="top-dast">
                Remaining sessions
              </v-tab> -->

              <v-tab-item class="p-4">
                <div class="report-toolbar mx-0 mb-4">
                  <div
                    class="
                      drop-tipe
                      d-flex
                      justify-content-center
                      align-items-center
                    "
                  >
                    <v-autocomplete
                      class="checkScroller"
                      v-if="allCourseList"
                      :items="allCourseList"
                      prepend-inner-icon="search"
                      :disabled="loadCourse"
                      :loading="loadCourse"
                      return-object
                      hide-details
                      :item-text="'EventFullName'"
                      :item-value="'EventId'"
                      v-model="selectedCourse"
                      clearable
                      placeholder="Select Course"
                      dense
                      outlined
                      @change="getstudentsDataByCourseId(selectedCourse)"
                    >
                    </v-autocomplete>
                  </div>
                  <v-btn
                    small
                    v-if="selectedCourse != null"
                    color="blue"
                    class="ml-2"
                    @click="getstudentsDataByCourseId(selectedCourse)"
                    outlined
                  >
                    <v-icon color="#1976d2" class="mr-1">
                      mdi-refresh-circle
                    </v-icon>
                    Reload
                  </v-btn>
                  <div
                    class="report-search d-none"
                    v-if="selectedCourse != null"
                  >
                    <v-icon depressed color="#8a8a8a" size="25"
                      >mdi-magnify</v-icon
                    >
                    <input
                      type="text"
                      class="search-input"
                      id=""
                      value=""
                      placeholder="search courses..."
                      v-model="searchVal"
                    />
                  </div>
                </div>
                <div class="class-tab-header">
                  <div class="class-tab-header-left">
                    <h3>Resource Library</h3>

                    <h5>{{ filteredResourceList.length }} Items</h5>
                  </div>
                  <div class="class-tab-header-right">
                    <div class="class-search-questions">
                      <v-icon depressed size="25px" color="#8a8a8a"
                        >mdi-magnify</v-icon
                      >
                      <input
                        type="text"
                        placeholder="Search"
                        v-model="searchVal"
                      />
                    </div>

                    <v-menu offset-y>
                      <template v-slot:activator="{ on, attrs }">
                        <div class="class-filter-wrap" v-bind="attrs" v-on="on">
                          <v-icon depressed size="25px" color="#000"
                            >mdi-filter-variant</v-icon
                          >
                          <p>Filter</p>
                        </div>
                      </template>
                      <v-list class="p-0">
                        <v-list-item
                          v-for="(item, index) in resourceTypes"
                          :key="index"
                          dense
                          class="resource-types"
                        >
                          <v-list-item-title
                            @click="resourceFiter(item.title)"
                            >{{ item.title }}</v-list-item-title
                          >
                        </v-list-item>
                      </v-list>
                    </v-menu>
                  </div>
                </div>
                <div class="class-table-chart">
                  <div v-if="filteredResourceList.length == 0">
                    <div class="report-table-no-data">
                      <v-icon depressed color="#8a8a8a" size="80"
                        >mdi-semantic-web</v-icon
                      >
                      <p>No Resource Found</p>
                    </div>
                  </div>
                  <table v-else>
                    <thead class="table-scroll">
                      <tr>
                        <!-- <th>
                          <v-checkbox
                            v-model="selected"
                            label=""
                            value=""
                          ></v-checkbox>
                        </th> -->
                        <th width="55%">Name</th>
                        <th width="20%">Description</th>
                        <th width="15%">Size</th>
                        <th width="10%">&nbsp;</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr
                        v-for="resource in filteredResourceList"
                        :key="resource.ResourceId"
                      >
                        <!-- <td>
                          <v-checkbox
                            v-model="selected"
                            label=""
                            value=""
                          ></v-checkbox>
                        </td> -->
                        <td>
                          <div
                            class="
                              flie-wrap
                              d-flex
                              justify-content-start
                              align-items-center
                            "
                          >
                            <span class="mr-2" v-if="resource.Type == 'PDF'"
                              ><img src="../assets/Images/icons/pdf-class.svg"
                            /></span>
                            <span class="mr-2" v-if="resource.Type == 'VIDEO'"
                              ><img
                                src="../assets/Images/icons/video-class.svg"
                            /></span>
                            <span class="mr-2" v-if="resource.Type == 'IMAGE'"
                              ><img
                                src="../assets/Images/icons/image-class.svg"
                            /></span>
                            <span class="mr-2" v-if="resource.Type == 'LINK'"
                              ><img src="../assets/Images/icons/link-class.svg"
                            /></span>
                            <span class="mr-2" v-if="resource.Type == 'PPT'"
                              ><img src="../assets/Images/icons/icon-ppt.svg"
                            /></span>

                            <h4 class="m-0" v-if="resource.Type == 'LINK'">
                              <a :href="resource.ResourcePath" target="_blank">
                                {{ resource.DisplayName }}
                              </a>
                            </h4>
                            <h4 class="m-0" v-else>
                              {{ resource.DisplayName }}
                            </h4>
                          </div>
                        </td>
                        <td>
                          <p class="class-date m-0">
                            {{ resource.Description }}
                          </p>
                        </td>
                        <td>
                          <p class="class-flie-size m-0">
                            {{ resource.ResourceSize }}
                          </p>
                        </td>
                        <td style="text-align: center">
                          <v-btn
                            dark
                            depressed
                            small
                            color="success"
                            v-if="
                              resource.Type == 'PDF' || resource.Type == 'PPT'
                            "
                            @click="downloadOrViewFile(resource)"
                            >Download</v-btn
                          >
                          <!-- <a
                            href="javascript:void(0)"
                            v-if="
                              resource.Type == 'PDF' || resource.Type == 'PPT'
                            "
                            @click="downloadOrViewFile(resource)"
                            ><v-icon depressed color="#8a8a8a" size="25px"
                              >mdi-download</v-icon
                            ></a
                          > -->
                          <v-btn
                            dark
                            depressed
                            small
                            color="success"
                            v-if="resource.Type == 'VIDEO'"
                            @click="downloadOrViewFile(resource)"
                            >Watch Now</v-btn
                          >
                          <v-btn
                            dark
                            depressed
                            small
                            color="success"
                            v-if="resource.Type == 'IMAGE'"
                            @click="downloadOrViewFile(resource)"
                            >View</v-btn
                          >
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-tab-item>
            </v-tabs>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      scrollable
      content-class="client-dialog resource-dialog"
      transition="scroll-x-reverse-transition"
      v-model="certificateDialog"
      width="auto"
    >
      <v-card style="min-height: 87vh; opacity: 0.97">
        <v-card-title>
          <div
            class="
              resource-head
              p-4
              d-flex
              justify-content-between
              align-items-center
            "
            style="width: 100%"
          >
            <h3 class="m-0">Certificates</h3>
            <div style="">
              <v-icon style="z-index: 2" size="32" @click="closeHandler()"
                >close</v-icon
              >
            </div>
          </div></v-card-title
        >
        <v-card-text id="ClientLobbyCard" style="p-0;font-size:1rem">
          <div class="resource-tab-area" style="width: 100%; height: 100%">
            <v-tabs vertical>
              <v-tab class="top-dast"> My Certificates </v-tab>

              <v-tab-item class="p-4">
                <div
                  class="report-toolbar"
                  v-if="clientCertificateSelector == true"
                >
                  <div
                    class="
                      drop-tipe
                      d-flex
                      justify-content-center
                      align-items-center
                    "
                  >
                    <v-autocomplete
                      v-if="allStudentsList"
                      :items="allStudentsList"
                      prepend-inner-icon="search"
                      clearable
                      return-object
                      hide-details
                      :item-text="'Name'"
                      :item-value="'Id'"
                      v-model="selectedStudent"
                      placeholder="Select Student"
                      dense
                      outlined
                      @change="getStudentsCertificates(selectedStudent)"
                      :loading="loadStudent"
                    >
                    </v-autocomplete>
                  </div>
                </div>
                <div
                  class="report-table-no-data"
                  v-if="
                    clientCertificateSelector == true &&
                    certificateData.length == 0
                  "
                >
                  <v-icon depressed color="#8a8a8a" size="80"
                    >mdi-file-certificate</v-icon
                  >
                  <p>Please select a student to view certificate</p>
                </div>

                <div
                  class="report-table-no-data"
                  v-if="noCertificateMsgShow == true"
                >
                  <v-icon depressed color="#8a8a8a" size="80"
                    >mdi-file-certificate</v-icon
                  >
                  <p>You don't have any certificates to display</p>
                </div>
                <div
                  class="class-table-chart"
                  v-if="certificateData.length > 0"
                >
                  <table>
                    <thead class="table-scroll">
                      <tr>
                        <th width="45%">Course Name</th>
                        <th width="30%">Course Progress</th>
                        <th width="25%">Download</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="(course, index) in certificateData"
                        :key="course[index].course_id"
                      >
                        <td>
                          <div
                            class="
                              flie-wrap
                              d-flex
                              justify-content-start
                              align-items-center
                            "
                          >
                            <h4 class="m-0">{{ course[index].course_name }}</h4>
                          </div>
                        </td>
                        <td>
                          <p
                            class="certificate-progress"
                            v-if="course[index].completionPercentage < 100"
                          >
                            <v-progress-linear
                              :color="
                                course[index].completionPercentage > 10 &&
                                course[index].completionPercentage < 40
                                  ? 'amber'
                                  : course[index].completionPercentage > 40 &&
                                    course[index].completionPercentage < 60
                                  ? 'blue'
                                  : course[index].completionPercentage > 60 &&
                                    course[index].completionPercentage < 80
                                  ? 'light-green'
                                  : course[index].completionPercentage >= 100
                                  ? 'Success'
                                  : ''
                              "
                              slot="extension"
                              v-model="course[index].completionPercentage"
                              class="ma-0"
                            ></v-progress-linear>
                            <span class="progress-number"
                              >{{ course[index].attended_sessions }}/{{
                                course[index].purchased_sessions
                              }}</span
                            >
                          </p>
                          <p v-else class="m-0">
                            <v-chip
                              class="ma-2"
                              color="green"
                              text-color="green"
                              outlined
                              small
                            >
                              Completed
                            </v-chip>
                          </p>
                        </td>
                        <td v-if="course[index].course_completed == true">
                          <v-btn
                            dark
                            depressed
                            small
                            color="success"
                            @click="getHtmlToPdf(course[index])"
                            >Download</v-btn
                          >
                        </td>
                        <td v-else>
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on }">
                              <v-btn v-on="on" small depressed disabled
                                >Download</v-btn
                              >
                            </template>
                            <span>Course Not Completed</span>
                          </v-tooltip>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </v-tab-item>
            </v-tabs>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      width="800"
      content-class="zoomDialogClass"
      v-model="sessionReviewDialog"
    >
      <v-card :height="currentStudent.Name == null ? '400' : 'auto'">
        <v-card-title>
          <div class="h3">Session Report</div>
          <div style="position: absolute; right: 10px; top: 10px">
            <v-icon style="z-index: 2" size="32" @click="closeHandler()"
              >close</v-icon
            >
          </div></v-card-title
        >
        <div
          style="width: 300px; margin: 0 auto"
          v-if="currentStudent.Name == null"
        >
          <v-autocomplete
            class="checkScroller"
            :items="allSessionDetails"
            :disabled="contentLoadedAuto"
            :loading="contentLoadedAuto"
            prepend-inner-icon="search"
            return-object
            hide-details
            :item-text="createdSessionName"
            v-model="selectedSession"
            clearable
            label="Search Session"
            dense
            outlined
            @change="getStudentsDetails(selectedSession)"
          >
          </v-autocomplete>
        </div>
        <div
          style="width: 300px; margin: 0 auto"
          class="mt-5"
          v-if="
            allStudentsListBySession.length > 0 && currentStudent.Name == null
          "
        >
          <v-select
            :items="allStudentsListBySession"
            label="Select Student"
            item-text="Name"
            dense
            v-model="selectedStudentForReview"
            outlined
            return-object
            @change="getStudentsDetailsForReview(selectedStudentForReview)"
          ></v-select>
        </div>

        <v-card-text v-if="currentStudent.Name != null">
          <v-container ref="studentRatingForm">
            <v-row>
              <v-col class="h5 py-1"
                ><span style="font-weight: bolder">Student Name:</span>
                {{ currentStudent.Name }}</v-col
              >
              <v-col class="h5 py-1"
                ><span style="font-weight: bolder">Teacher Name:</span>
                {{
                  studentSessionData.MappedHosts
                    ? studentSessionData.MappedHosts[0].Name
                    : ""
                }}</v-col
              >
            </v-row>
            <v-row>
              <v-col class="h5 py-1">
                <span style="font-weight: bolder">Course Name:</span>
                {{
                  studentSessionData
                    ? studentSessionData.eventInfo
                      ? studentSessionData.eventInfo.EventFullName
                      : ""
                    : ""
                }}
              </v-col>
              <v-col class="h5 py-1">
                <span style="font-weight: bolder">Session Name:</span>
                {{ studentSessionData.Name }}
              </v-col>
            </v-row>
            <v-row>
              <v-col class="h5 py-1"
                ><span style="font-weight: bolder">Session Date:</span>
                {{
                  getStudentRatingSessionDate(
                    studentSessionData.StartDate
                      ? studentSessionData.StartDate._seconds * 1000
                      : ""
                  )
                }}</v-col
              >
              <v-col class="h5 py-1"
                ><span style="font-weight: bolder">Session time:</span>
                {{
                  getStudentRatingSessionTime(
                    studentSessionData.StartDate
                      ? studentSessionData.StartDate._seconds * 1000
                      : ""
                  )
                }}</v-col
              >
            </v-row>
            <v-divider style="border-bottom-width: thin"></v-divider>
            <v-row>
              <v-col cols="4">
                <span
                  style="align-self: center; font-weight: bolder"
                  class="h5"
                >
                  Understanding:</span
                >
              </v-col>
              <v-col class="pt-0"
                ><v-rating
                  length="10"
                  v-model="studentUnderstandingRating"
                  background-color="green lighten-3"
                  color="green"
                  large
                ></v-rating
              ></v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <span style="align-self: center; font-weight: bolder" class="h5"
                  >Oral/Written Performance:</span
                ></v-col
              >
              <v-col class="pt-0"
                ><v-rating
                  length="10"
                  v-model="studentOralWritingRating"
                  background-color="green lighten-3"
                  color="green"
                  large
                ></v-rating
              ></v-col>
            </v-row>
            <v-row>
              <v-col
                style="justify-content: flex-start; display: flex"
                cols="4"
              >
                <span
                  style="align-self: center; font-weight: bolder"
                  class="h5"
                >
                  Previous Assignment Feedback:</span
                ></v-col
              >
              <v-col
                ><v-text-field
                  v-model="studentPreviousHomework"
                  hint="Previous Assignment Feedback"
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row>
              <v-col
                style="justify-content: flex-start; display: flex"
                cols="4"
              >
                <span style="align-self: center; font-weight: bolder" class="h5"
                  >Assignment:</span
                ></v-col
              >
              <v-col>
                <v-text-field
                  v-model="studentHomework"
                  hint="Assignment"
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row>
              <v-col style="justify-content: flex-start; display: flex" cols="4"
                ><span
                  style="align-self: center; font-weight: bolder"
                  class="h5"
                  >Additional Remark:</span
                ></v-col
              >

              <v-col
                ><v-text-field
                  v-model="studentRemarks"
                  hint="Additional Remarks"
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row justify="end">
              <v-btn
                @click="backToSessionListing()"
                color="#696969"
                class="mr-2"
                >Back</v-btn
              >

              <v-btn
                @click="
                  reviewStudent(
                    currentStudent.Name,
                    studentSessionData.MappedHosts[0].Name,
                    studentSessionData.eventInfo.EventFullName,
                    studentSessionData.StartDate._seconds * 1000,
                    studentSessionData.Name
                  )
                "
                :disabled="studentSubmitDisabled"
                color="primary"
                >Submit</v-btn
              >
            </v-row>
          </v-container>
        </v-card-text>
      </v-card></v-dialog
    >
    <v-dialog v-model="ratingFeedbacksDialog" max-width="950">
      <v-card>
        <v-card-title class="text-h5"> {{ feedbackHeader }} </v-card-title>
        <v-card-text>
          <table class="table">
            <thead>
              <tr>
                <th width="30%">Stars</th>
                <th width="50%">RatingText</th>
                <th width="20%">Rated On</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <v-rating
                    length="5"
                    v-model="ratedStars"
                    background-color="green lighten-3"
                    color="green"
                    small
                    dense
                    readonly
                  ></v-rating>
                </td>
                <td>{{ ratedText }}</td>
                <td>{{ ratedOn }}</td>
              </tr>
            </tbody>
          </table>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="rescheduleDialog"
      width="600"
      content-class="profile-dialog-wrap"
    >
      <v-card style="min-height: 180px; border-radius: 0 !important">
        <h4
          style="
            justify-content: flex-start;
            align-items: flex-start;
            display: flex;
            margin-left: 10px;
          "
        >
          Reschedule Session
        </h4>
        <div style="position: absolute; right: 10px; top: 15px">
          <v-icon style="z-index: 2" size="32" @click="rescheduleDialog = false"
            >close</v-icon
          >
        </div>

        <v-row class="p-5">
          <v-col md="5">
            <label>Start Date:</label>
            <date-picker
              v-model="rescheduledStartDate"
              type="datetime"
              placeholder="Select datetime"
              :show-time-panel="showTimePanel"
              @close="handleOpenChange"
              :show-second="false"
              :disabled-date="notBeforeToday"
              value-type="timestamp"
            >
              <template v-slot:footer>
                <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                  {{ showTimePanel ? "select date" : "select time" }}
                </button>
              </template>
            </date-picker>
          </v-col>
          <v-col md="5">
            <label>End Date:</label>
            <date-picker
              v-model="rescheduledEndDate"
              type="datetime"
              placeholder="Select datetime"
              :show-time-panel="showTimePanel"
              @close="handleOpenChange"
              :show-second="false"
              :disabled-date="notBeforeToday"
              value-type="timestamp"
            >
              <template v-slot:footer>
                <button class="mx-btn mx-btn-text" @click="toggleTimePanel">
                  {{ showTimePanel ? "select date" : "select time" }}
                </button>
              </template>
            </date-picker>
          </v-col>

          <v-col md="2">
            <div
              class="pt-5"
              style="margin-top: 5px"
              v-if="rescheduledStartDate != null && rescheduledEndDate != null"
            >
              <v-btn color="primary" @click="makeSessionRescheduled()"
                >Submit</v-btn
              >
            </div>
          </v-col>
        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>



<script>
import common from "@/common";
import firebase from "firebase";
import db from "../components/firebaseInit";
import axios from "axios";
import APIs from "@/components/APIInit";
import store from "../store";
import jwt_decode from "jwt-decode";
import XLSX from "xlsx";
import { bus } from "@/main";
import moment from "moment-timezone";
var CLIENT_ID = store.state.client[0].id;
const INSTANCE_ID = process.env.VUE_APP_INSTANCE_ID;
import apiHandler from "../handler/edu_handler";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";

// import jQuery from "jquery";
// let $ = jQuery;
var self;
export default {
  name: "ClientLobby",
  data() {
    return {
      totalStudentsCountForDashboard: null,
      activeStudentsCountForDashboard: null,
      totalTeachersCountForDashboard: null,
      totalSessionsTodayCountForDashboard: null,
      totalTrialClassCountForDashboard: null,
      selectedCourseProgress: null,
      courseProgressHeaders: [],
      courseProgressData: [],
      ownStudentsData: [],
      selectedStudents: [],
      selectedTeachers: [],
      selectedUpcomingSessions: [],
      selectedPastSessions: [],
      singleSelect: false,
      studentsFilter: ["All", "Active Students", "Past Students"],
      selectedStudentFilter: "All",
      currentSessionId: null,
      rescheduledStartDate: null,
      rescheduledEndDate: null,
      showTimePanel: false,
      rescheduleDialog: false,
      ratedStars: null,
      ratedText: null,
      ratedOn: null,
      feedbackHeader: null,
      ratingFeedbacksDialog: false,
      allStudentsListBySession: [],
      selectedSession: {},
      selectedStudentForReview: {},
      contentLoadedAuto: false,
      allSessionDetails: [],
      studentUnderstandingRating: "",
      studentOralWritingRating: "",
      studentPreviousHomework: "",
      studentHomework: "",
      studentRemarks: "",
      currentStudent: {},
      studentSessionData: {},
      sessionReviewDialog: false,
      certificateDialog: false,
      resourceTypes: [
        { title: "ALL" },
        { title: "PDF" },
        { title: "IMAGE" },
        { title: "VIDEO" },
        { title: "PPT" },
        { title: "LINK" },
      ],
      filterByCategory: "",
      resourceDialog: false,
      clientResource: [],
      showSessionFeedbackMenu: false,
      showCourseFeedbackMenu: false,
      showSessionReportMenu: false,
      showResourceFeedbackMenu: false,
      showCertificatesMenu: false,
      sessionDetailTooltip: null,
      feedbackTableHeaderData: [],
      teacherFeedbackData: [],
      studentFeedbackData: [],
      allFeedbackData: [],
      feedbackDialog: false,
      feedbackHtml: "",
      progressReports: [],
      progressReportsHeaders: [],
      tableLoader: false,
      classMonitoringHeaders: [],
      sessionData: [],
      tableData: [],
      selectedSubTabs: 0,
      showTabs: false,
      posReports: [
        { title: "User Report" },
        { title: "Trial Report" },
        { title: "Order Report" },
        { title: "Course Completion Report" },
      ],
      loadCourse: false,
      reportDialog: false,
      selectedCourse: null,
      selectedStudent: null,
      getTimeInterVal: "",
      currentTime: new Date().getTime(),
      path: "../views/edu/Assignment.vue",
      profileView: false,
      profileViewUrl: "",
      profileViewHeaderText: "",
      html: "",
      dialog: false,
      menuExpandedState: false,
      items: [],
      version: "",
      drawer: false,
      group: null,
      selectedItem: 0,
      showMenu: null,
      menuLabel: null,
      menuItems: [],
      allCourseList: [],
      APIs: APIs,
      headers: [{ text: "NAME", value: "name", width: "200px", fixed: true }],
      students: [],
      selected0: [],
      selected2: [],
      selected3: [],
      selected5: [],
      loadDashboardData: false,
      searchVal: "",
      certificateData: [],
      noCertificateMsgShow: false,
      clientCertificateSelector: false,
      allStudentsList: [],
      loadStudent: false,
      teacherDetailsLoaded: false,
      teacherTableHeaderData: [],
      teacherData: [],
      allStudentData: [],
      allStudentTableHeaderData: [],
      search: "",
      searchTeacher: "",
      showSelectedTab: "overview",
      allUsersListOfClient: [],
      selectedUser: null,
      loadUser: false,
      selectedSubTabsSummary: null,
      selectedSubSessionTabsSummary: null,
    };
  },
  components: { DatePicker },
  computed: {
    studentSubmitDisabled() {
      return (
        !this.studentUnderstandingRating ||
        !this.studentOralWritingRating ||
        !this.studentPreviousHomework ||
        !this.studentHomework ||
        !this.studentRemarks
      );
    },
    dynamicComponent() {
      // let self=this
      return () =>
        import(/* webpackChunkName: "about" */ "../views/edu/Sessions.vue");
    },
    filteredResourceList() {
      return this.clientResource.filter((resource) => {
        if (this.searchVal != "") {
          return resource.ResourceName.toLowerCase().includes(
            this.searchVal.toLowerCase()
          );
        } else if (this.filterByCategory != "") {
          return resource.Type.toLowerCase().includes(
            this.filterByCategory.toLowerCase()
          );
        } else {
          return resource;
        }
      });
    },
    filterStudentsData() {
      return this.allStudentData.filter((students, index) => {
        students.id = index;
        if (this.selectedStudentFilter == "Active Students") {
          if (students.course_completed == "No") {
            return students;
          }
        } else if (this.selectedStudentFilter == "Past Students") {
          if (students.course_completed == "Yes") {
            return students;
          }
        } else {
          return students;
        }
      });
    },
    filterAllStudentsByCourseId() {
      return this.allUsersListOfClient.filter((students) => {
        if (this.selectedCourseProgress != null) {
          if (students.course_id == this.selectedCourseProgress.EventId) {
            console.log("students>>>>>>>>>>>>>>>", students);

            return students;
          }
        } else {
          return students;
        }
      });
    },
  },
  watch: {
    group() {
      this.drawer = false;
    },
    currentTime(val) {
      let currentTime = parseInt(val / 1000);
      if (this.$store.state.feedbackLastSession.EndDate) {
        let endTime = this.$store.state.feedbackLastSession.EndDate._seconds;
        if (currentTime > endTime && currentTime < endTime + 5) {
          this.$router.replace({
            path: "/mainlobby" + "/session_cal",
            query: { feedback: true },
          });

          this.dialog = true;
        }
      }
    },
    dialog(val) {
      if (!val) {
        this.$nextTick(() => {
          this.$router.push("/mainlobby");
          this.$store.commit("addEventCollection", "");
          this.$store.commit("addEventID", "");
        });
      }
    },
    menuExpandedState(state) {
      console.log(state);
    },
  },
  destroyed() {
    clearInterval(this.getTimeInterVal);
  },
  mounted() {
    this.getClientDetails();
    document.title = `Welcome ${this.$store.state.user[0].fname} - ${this.$store.state.client[0].name}`;
    this.version = document.querySelector('meta[name="version"]').content;
    //this.items.push({ title: "My Courses" });
    //if (this.$store.state.eventCount > 1)
    // this.items.push({ title: "Select My Course" });
    //this.items.push({ title: "Log Out" });
    this.$store.commit("setDefaultLoginLandingPage", "/clientLobby");
    this.$store.commit("addEventID", "");
    this.html = this.$store.state.ClientLobbyHTML;

    let self = this;
    this.$nextTick(() => {
      let allAtags = document.getElementsByTagName("a");
      allAtags.forEach((tag) => {
        let tagHref = tag.getAttribute("href");
        if (tagHref.includes("/")) {
          tag.removeAttribute("href");
          tag.addEventListener("click", () => {
            if (tagHref == "/menu") {
              self.drawer = !self.drawer;
            } else {
              self.routerHandler(tagHref);
            }
          });
        }
      });
    });
    var obj = JSON.parse(window.localStorage.getItem("my-app"));
    if (obj.branding[0].favicon != undefined) {
      if (obj.branding[0].favicon != "") {
        var link =
          document.querySelector("link[rel*='icon']") ||
          document.createElement("link");
        link.type = "image/x-icon";
        link.rel = "shortcut icon";
        link.href = obj.branding[0].favicon;
        document.getElementsByTagName("head")[0].appendChild(link);
      }
    }
  },
  created() {
    let self = this;
    this.getTimeInterVal = setInterval(function () {
      self.currentTime = Date.now();
    }, 1000);
  },
  methods: {
    goToJoinYourClass() {
      this.reportDialog = false;
      self.routerHandler("/session_cal");
    },
    getDashboardDetails() {
      let headers = {
        Authorization: "Basic YXBpYWRtaW46I2FiY2QxMjM=",
        "content-type": "application/json",
      };

      axios({
        method: "get",
        url: "https://cms.edulife.sg/api/v1/trial/report",
        responseType: "json",
        headers: headers,
      })
        .then((response) => {
          console.log("response>>>>>444>>>>", response.data.length);
          this.totalTrialClassCountForDashboard = response.data.length;
        })
        .catch(() => console.log("error occured"));
      axios({
        method: "get",
        url: "https://us-central1-e2medu.cloudfunctions.net/e2medu-v2-prd-count-stat",
        responseType: "json",
      })
        .then((response) => {
          this.totalStudentsCountForDashboard = response.data.summary.student;
          this.activeStudentsCountForDashboard =
            response.data.summary.active_students;
          this.totalTeachersCountForDashboard = response.data.summary.teachers;
          this.totalSessionsTodayCountForDashboard =
            response.data.summary.todays_sessions;
        })
        .catch(() => console.log("error occured"));
    },
    getCourseSpecificAttendance(courseSelected) {
      console.log("courseSelected-=======", courseSelected.EventId);
      console.log(
        "allUsersListOfClient============",
        self.allUsersListOfClient
      );

      self.tableLoader = true;

      self.courseProgressData = [];
      (self.search = ""),
        (self.courseProgressHeaders = [
          {
            text: "Name",
            value: "user_name",
            width: "200px",
            fixed: true,
          },
          {
            text: "Course Name",
            value: "course_name",
            width: "200px",
            fixed: true,
          },
          { text: "Email", value: "user_email", width: "200px", fixed: true },
          {
            text: "Course Completed",
            value: "course_completed",
            width: "200px",
            fixed: true,
          },
          {
            text: "Total Sessions",
            value: "purchased_sessions",
            width: "200px",
            fixed: true,
          },
          {
            text: "Attended Sessions",
            value: "attended_sessions",
            width: "200px",
            fixed: true,
          },
          {
            text: "Upcoming Sessions",
            value: "upcoming_sessions",
            width: "200px",
            fixed: true,
          },
          {
            text: "Missed Sessions",
            value: "postponed_sessions",
            width: "200px",
            fixed: true,
          },
          {
            text: "View Details",
            value: "details",
            width: "200px",
            fixed: true,
          },
        ]);
      let headers = {
        "content-type": "application/json",
      };

      axios
        .get(
          "https://us-central1-e2medu.cloudfunctions.net/e2medu-v2-prd-user-stat",
          {
            headers: headers,
          }
        )
        .then((response) => {
          var responseData = response.data.data.filter(function (element) {
            return element.last_session_end_date > 0;
          });

          responseData.map((data) => {
            data.last_session_end_date = this.SetTimeByZone(
              new Date(data.last_session_end_date * 1000).toUTCString(),
              moment.tz.guess()
            );

            data.last_session_start_date = this.SetTimeByZone(
              new Date(data.last_session_start_date * 1000).toUTCString(),
              moment.tz.guess()
            );

            data.Registered_On = this.SetTimeByZone(
              new Date(data.Registered_On * 1000).toUTCString(),
              moment.tz.guess()
            );
            data.Last_Accessed_On = this.SetTimeByZone(
              new Date(data.Last_Accessed_On * 1000).toUTCString(),
              moment.tz.guess()
            );
            data.course_completed =
              data.course_completed == true ? "Yes" : "No";
            data.details = true;
            if (data.course_id == courseSelected.EventId) {
              self.courseProgressData.push(data);
            }
          });
          self.courseProgressData.sort(function (a, b) {
            let aName = a.user_name;
            let bName = b.user_name;
            if (aName < bName) {
              return -1;
            }
            if (aName > bName) {
              return 1;
            }
            return 0;
          });
          console.log("allStudentData-=======", self.courseProgressData);

          self.tableLoader = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getStudentProgressByUserId() {
      let headers = {
        "content-type": "application/json",
      };

      let rqstData = {};

      rqstData = {
        key: {
          clientId: this.$store.state.client[0].id,
        },

        data: {
          attendeeId: this.$store.state.user[0].id,
        },
      };
      axios
        .post(
          "https://us-central1-e2medu.cloudfunctions.net/e2medu-v2-prd-attendee-stat",
          rqstData,
          {
            headers: headers,
          }
        )
        .then((responseData) => {
          this.ownStudentsData = [];
          responseData.data.data.map((course) => {
            course.last_session_end_date = this.SetTimeByZone(
              new Date(course.last_session_end_date * 1000).toUTCString(),
              moment.tz.guess()
            );
            course.completionPercentage = Math.round(
              (parseInt(course.attended_sessions) /
                parseInt(course.purchased_sessions)) *
                100
            );

            this.ownStudentsData.push(responseData.data.data);
          });
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    handleClick(value) {
      console.log(value);
    },

    getAllUsersByClientId() {
      let headers = {
        "Content-Type": "application/json",
      };
      let rqstData = {};

      rqstData = {
        key: {
          clientId: this.$store.state.client[0].id,
        },
      };
      axios
        .post(
          "https://us-central1-e2medu.cloudfunctions.net/e2medu-v2-prd-get-users",
          rqstData,
          {
            headers: headers,
          }
        )
        .then((responseData) => {
          responseData.data.data.map((user) => {
            if (!user.user_email.includes("webspiders")) {
              self.allUsersListOfClient.push(user);
            }
          });
          self.allUsersListOfClient.sort((a, b) =>
            b.user_name > a.user_name ? -1 : b.user_name > a.user_name ? 1 : 0
          );
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    showUserSelectedCourse(data) {
      self.selectedCourse = {
        EventId: data.course_id,
        EventFullName: data.course_name,
      };

      self.selectedUser = {
        course_id: data.course_id,
        course_name: data.course_name,
        user_id: data.User_Id,
        user_name: data.user_name,
        user_email: data.user_email,
      };
      self.getSessionsByEventId(self.selectedCourse);

      self.showSelectedTab = "monitoring";
    },
    getStudentList(type) {
      self.tableLoader = true;
      self.allStudentData = [];
      (self.search = ""),
        (self.allStudentTableHeaderData = [
          {
            text: "Name",
            value: "user_name",
            width: "200px",
            fixed: true,
          },
          {
            text: "Course Name",
            value: "course_name",
            width: "200px",
            fixed: true,
          },
          { text: "Email", value: "user_email", width: "200px", fixed: true },
          {
            text: "Course Completed",
            value: "course_completed",
            width: "200px",
            fixed: true,
          },
          {
            text: "Total Sessions",
            value: "purchased_sessions",
            width: "200px",
            fixed: true,
          },
          {
            text: "Attended Sessions",
            value: "attended_sessions",
            width: "200px",
            fixed: true,
          },
          {
            text: "Upcoming Sessions",
            value: "upcoming_sessions",
            width: "200px",
            fixed: true,
          },
          {
            text: "Missed Sessions",
            value: "postponed_sessions",
            width: "200px",
            fixed: true,
          },
          {
            text: "View Details",
            value: "details",
            width: "200px",
            fixed: true,
          },
        ]);
      let headers = {
        "content-type": "application/json",
      };

      axios
        .get(
          "https://us-central1-e2medu.cloudfunctions.net/e2medu-v2-prd-user-stat",
          {
            headers: headers,
          }
        )
        .then((response) => {
          var responseData = response.data.data.filter(function (element) {
            return element.last_session_end_date > 0;
          });

          responseData.map((data) => {
            data.last_session_end_date = this.SetTimeByZone(
              new Date(data.last_session_end_date * 1000).toUTCString(),
              moment.tz.guess()
            );

            data.last_session_start_date = this.SetTimeByZone(
              new Date(data.last_session_start_date * 1000).toUTCString(),
              moment.tz.guess()
            );

            data.Registered_On = this.SetTimeByZone(
              new Date(data.Registered_On * 1000).toUTCString(),
              moment.tz.guess()
            );
            data.Last_Accessed_On = this.SetTimeByZone(
              new Date(data.Last_Accessed_On * 1000).toUTCString(),
              moment.tz.guess()
            );
            data.course_completed =
              data.course_completed == true ? "Yes" : "No";
            data.details = true;
            if (type == "All") {
              self.allStudentData.push(data);
            } else if (type == "Active") {
              if (data.course_completed == "No") {
                self.allStudentData.push(data);
              }
            } else if (type == "Past") {
              if (data.course_completed == "Yes") {
                self.allStudentData.push(data);
              }
            }
          });
          self.allStudentData.sort(function (a, b) {
            let aName = a.user_name;
            let bName = b.user_name;
            if (aName < bName) {
              return -1;
            }
            if (aName > bName) {
              return 1;
            }
            return 0;
          });
          self.tableLoader = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    makeSessionRescheduled() {
      bus.$emit("toggleLoader", true);
      this.refreshTokenBeforeEventCall();
      let headers = {
        "Content-Type": "application/json",
        Authorization: "Bearer " + this.getSessionToken(),
      };
      let rqstData = {};

      rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: this.selectedCourse.EventId,
          sessionId: this.currentSessionId,
        },

        data: {
          StartDate: moment(this.rescheduledStartDate).utc().format(),
          EndDate: moment(this.rescheduledEndDate).utc().format(),
        },
      };
      axios
        .post(
          "https://us-central1-e2medu.cloudfunctions.net/e2medu-prd-reschedule-session",
          rqstData,
          {
            headers: headers,
          }
        )
        .then((responseData) => {
          if (responseData.data.status == -34) {
            this.showSnackbar("Session Re-schedule limit reached!");
            bus.$emit("toggleLoader", false);
            this.rescheduleDialog = false;
          } else if (responseData.data.status == -3) {
            this.showSnackbar(
              "Session cannot be Re-scheduled, please contact event support "
            );
            bus.$emit("toggleLoader", false);
            this.rescheduleDialog = false;
          } else {
            this.showSnackbar("Session Re-scheduled Succesfully!");
            this.getstudentsDataByCourseId(this.selectedCourse);
            bus.$emit("toggleLoader", false);
            this.rescheduleDialog = false;
          }
        })
        .catch((error) => {
          this.showSnackbar(
            "Session Re-scheduled failed, please contact event support"
          );
          bus.$emit("toggleLoader", false);
          console.log("Error:" + error);
        });
    },
    notBeforeToday(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return date.getTime() < today.getTime();
    },
    openRescheduleDialog(data) {
      this.currentSessionId = data;
      this.rescheduledStartDate = null;
      this.rescheduledEndDate = null;
      this.rescheduleDialog = true;
    },
    toggleTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    handleOpenChange() {
      this.showTimePanel = false;
    },
    showRatingFeedback(sessionName, data) {
      this.ratedStars = data.stars;
      this.ratedText = data.ratingText;
      this.ratedOn = this.SetTimeByZone(
        new Date(data.date).toUTCString(),
        moment.tz.guess()
      );
      this.feedbackHeader =
        "Feedback for " + sessionName + " By " + data.userName;
      this.ratingFeedbacksDialog = true;
    },

    downloadReports(data, name) {
      bus.$emit("toggleLoader", true);

      var contentWidth = this.formatExcelCols(data);

      var wscols = [];
      for (var i = 0; i < contentWidth.length; i++) {
        wscols.push({ wch: contentWidth[i].width });
      }
      let ws1 = XLSX.utils.json_to_sheet(data);
      ws1["!cols"] = wscols;

      var wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws1, name);
      XLSX.writeFile(wb, name + ".xlsx");
      bus.$emit("toggleLoader", false);
    },
    formatExcelCols(json) {
      let widthArr = Object.keys(json[0]).map((key) => {
        return { width: key.length + 2 }; // plus 2 to account for short object keys
      });
      for (let i = 0; i < json.length; i++) {
        let value = Object.values(json[i]);
        for (let j = 0; j < value.length; j++) {
          if (value[j] !== null && value[j].length > widthArr[j].width) {
            widthArr[j].width = value[j].length;
          }
        }
      }
      return widthArr;
    },
    reviewStudent(student, teacher, eventName, date, sessionName) {
      let studentDate = this.getStudentRatingSessionDate(date);
      let studentTime = this.getStudentRatingSessionTime(date);
      var html;
      if (location.host.includes("edulife")) {
        html = `<html lang="en-US"> <head> <link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,600;1,400;1,500&display=swap" rel="stylesheet"> <style>td {font-size:16px;font-weight:600;font-family: 'Poppins', sans-serif !important;} img{max-width:100%} </style> </head> <div class="" style="width:90%;margin:0 auto;background-color:#f2f2f2;padding:40px" > <div class="" style="width:600px;margin:0 auto;background-color:#ffffff;padding:40px" > <table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0" > <tbody> <tr> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;margin:0px;padding:0px;width:100%"> <tbody> <tr> <td style="padding-bottom:20px"> <a href="https://edulife.sg/home" target="_blank"> <img src="https://s3.amazonaws.com/unroll-images-production/projects%2F0%2F1623830177018-email-banner.jpg" width="600px"> </a> </td> </tr> </table> </tr> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:30px 10px 10px;font-family:'Lato',sans-serif;" align="left"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tbody> <tr> <td style="padding-right: 0px;padding-left: 0px;padding-bottom:15px" align="center"> <span style="font-size:18px;font-weight:600;border-bottom: 1px solid #000000;">SESSION REPORT</span> </td> </tr> </tbody> </table> </td> </tr> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding-top:40px;" align="left"> <table width="100%" cellpadding="0" cellspacing="0" border="0" style="font-size:16px;font-weight:600"> <tbody> <tr> <td style="padding-right: 0px;padding-left: 0px;" align="center"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tr> <td> <p style="">Session Date: ${studentDate} </p> </td> <td> <p style=""></p> </td> </tr> <tr> <td> <p style="">Student Name: ${student}</p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="">Course Name: ${eventName}</p> </td> <td> <p style=""> </p> </td> </tr> </table> </td> <td style="padding-right: 0px;" align="center"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tr> <td> <p style="">Session Time: ${studentTime}</p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="">Teacher Name: ${teacher}</p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="">Session Name: ${sessionName}</p> </td> <td> <p style=""> </p> </td> </tr> </table> </td> </tr> </tbody> </table> </td> </tr> <tr> <td style="padding-top:40px;"> <p>Understanding: ${this.studentUnderstandingRating}/10</p> <p>Oral/Written Class Performance: ${this.studentOralWritingRating}/10 </p> <p>Previous Assignment: ${this.studentPreviousHomework} </p> <p>Assignment : ${this.studentHomework} </p> <p>Additional Remark: ${this.studentRemarks} </p> </td> </tr> </tbody> </table> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;margin:0px;padding:0px;width:100%"> <tbody> <tr> <td style="padding:20px "> <img src="https://s3.amazonaws.com/unroll-images-production/projects%2F0%2F1623077639730-unnamed+%282%29.png" width="600px"> </td> </tr> </table> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;margin:0px;padding:0px;width:100%"> <tbody> <tr> <td> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%"> <tr> <td colspan="3" style="padding:0cm 0cm 0cm 0cm"> <p class="MsoNormal" align="center" style="text-align:center"> <span style="color:black"><a href="https://www.facebook.com/edulifesingapore" target="_blank"><span style="font-size:12.0pt;text-decoration:none"> <img border="0" width="18" height="18" style="width:.1875in;height:.1875in" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Ffacebook.png?alt=media" class="CToWUd"></span></a></span><span style="font-size:12.0pt;color:#222222">  </span><span style="color:black;padding:0 8px;"> <a href="https://www.instagram.com/edulifesg/" target="_blank" ><span style="font-size:12.0pt;text-decoration:none"> <img border="0" width="18" height="18" style="width:.1875in;height:.1875in" id="m_3276429931951355163m_4809426333270075598m_-7723710672828629258_x0000_i1027" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Finsta.png?alt=media" class="CToWUd"></span></a></span><span style="font-size:12.0pt;color:#222222">  </span><span style="color:black"> <a href="https://www.linkedin.com/in/edulife-singapore-b605a91b2/ " target="_blank"><span style="font-size:12.0pt;text-decoration:none"><img border="0" width="18" height="18" style="width:.1875in;height:.1875in" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Flinkdin.png?alt=media" class="CToWUd"></span></a></span> </p> <p align="center" style="margin-bottom:22.5pt;text-align:center"><span style="font-size:9.0pt;font-family:Times New Roman,serif;color:#222222">© Copyright EduLife 2021. All Rights Reserved<u></u><u></u></span></p> </td> </tr> </table> </td> </tr> </tbody> </table> </div> </div> </body> </html>`;
      } else {
        html = `<html lang="en-US"> <head> <link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,600;1,400;1,500&display=swap" rel="stylesheet"> <style>td {font-size:16px;font-weight:600;font-family: 'Poppins', sans-serif !important;} img{max-width:100%} </style> </head> <div class="" style="width:90%;margin:0 auto;background-color:#f2f2f2;padding:40px" > <div class="" style="width:600px;margin:0 auto;background-color:#ffffff;padding:40px" > <table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0" > <tbody> <tr> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;margin:0px;padding:0px;width:100%"> <tbody> <tr> <td style="padding-bottom:20px"> <a href="https://www.mastry.io/" target="_blank"> <img src="https://mars.webspiders.com/Prototype/Mastry/mastry.png" width="600px"> </a> </td> </tr> </table> </tr> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:30px 10px 10px;font-family:'Lato',sans-serif;" align="left"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tbody> <tr> <td style="padding-right: 0px;padding-left: 0px;padding-bottom:15px" align="center"> <span style="font-size:18px;font-weight:600;border-bottom: 1px solid #000000;">SESSION REPORT</span> </td> </tr> </tbody> </table> </td> </tr> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding-top:40px;" align="left"> <table width="100%" cellpadding="0" cellspacing="0" border="0" style="font-size:16px;font-weight:600"> <tbody> <tr> <td style="padding-right: 0px;padding-left: 0px;" align="center"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tr> <td> <p style="">Session Date: ${studentDate} </p> </td> <td> <p style=""></p> </td> </tr> <tr> <td> <p style="">Student Name: ${student}</p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="">Course Name: ${eventName}</p> </td> <td> <p style=""> </p> </td> </tr> </table> </td> <td style="padding-right: 0px;" align="center"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tr> <td> <p style="">Session Time: ${studentTime}</p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="">Teacher Name: ${teacher}</p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="">Session Name: ${sessionName}</p> </td> <td> <p style=""> </p> </td> </tr> </table> </td> </tr> </tbody> </table> </td> </tr> <tr> <td style="padding-top:40px;"> <p>Understanding: ${this.studentUnderstandingRating}/10</p> <p>Oral/Written Class Performance: ${this.studentOralWritingRating}/10 </p> <p>Previous Assignment: ${this.studentPreviousHomework} </p> <p>Assignment : ${this.studentHomework} </p> <p>Additional Remark: ${this.studentRemarks} </p> </td> </tr> </tbody> </table> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;margin:0px;padding:0px;width:100%"> <tbody> <tr> <td> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%"> <tr> <td colspan="3" style="padding:0cm 0cm 0cm 0cm"> <p class="MsoNormal" align="center" style="text-align:center"> <span style="color:black"><a href="https://www.facebook.com/Mastry-118511360415858" target="_blank"><span style="font-size:12.0pt;text-decoration:none"> <img border="0" width="18" height="18" style="width:.1875in;height:.1875in" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Ffacebook.png?alt=media" class="CToWUd"></span></a></span><span style="font-size:12.0pt;color:#222222"> </span><span style="color:black;padding:0 8px;"> <a href="https://www.instagram.com/mastry.io/" target="_blank" ><span style="font-size:12.0pt;text-decoration:none"> <img border="0" width="18" height="18" style="width:.1875in;height:.1875in" id="m_3276429931951355163m_4809426333270075598m_-7723710672828629258_x0000_i1027" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Finsta.png?alt=media" class="CToWUd"></span></a></span><span style="font-size:12.0pt;color:#222222"> </span><span style="color:black"> <a href="https://www.linkedin.com/company/mastry-io" target="_blank"><span style="font-size:12.0pt;text-decoration:none"><img border="0" width="18" height="18" style="width:.1875in;height:.1875in" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Flinkdin.png?alt=media" class="CToWUd"></span></a></span> </p> <p align="center" style="margin-bottom:22.5pt;text-align:center"><span style="font-size:9.0pt;font-family:Times New Roman,serif;color:#222222">© Copyright Mastry 2021. All Rights Reserved<u></u><u></u></span></p> </td> </tr> </table> </td> </tr> </tbody> </table> </div> </div> </body> </html>`;
      }
      let key = {
        sessionId: this.studentSessionData.SessionId,
        clientId: this.$store.state.client[0].id,
        eventId: this.studentSessionData.eventId,
        userId: this.$store.state.user[0].id,
      };
      let studentRatingObject = {
        student,
        teacher,
        eventName,
        date: new Date(date).getTime(),
        sessionName,
        studentUnderstandingRating: this.studentUnderstandingRating,
        studentOralWritingRating: this.studentOralWritingRating,
        studentPreviousHomework: this.studentPreviousHomework,
        studentHomework: this.studentHomework,
        studentRemarks: this.studentRemarks,
      };
      apiHandler.setSessionParticipantsReviews({
        key,
        data: studentRatingObject,
      });
      this.sendStudentRatingMail(html);
      this.showSnackbar("Successfully Rated Student");
      this.closeHandler();
    },
    sendStudentRatingMail(htmlParam) {
      let to = [this.currentStudent.Email,'support@edulife.sg'];
      var from;
      var cc;
      var bcc;
      if (location.host.includes("edulife"))
        from = { email: "feedback@edulife.sg", name: "EduLife Feedback" };
      else from = { email: "support@mastry.io", name: "Team Mastry" };
      bcc = this.studentSessionData.MappedHosts[0].Email;
     // bcc = [this.studentSessionData.MappedHosts[0].Email , 'support@edulife.sg'];
      if (location.host.includes("edulife")) {
        cc = "feedback@edulife.sg";
        // bcc = bcc;
      } else {
        cc = "debottam.bhatt@webspiders.com,debashis.giri@webspiders.com";
        bcc = bcc + ",feedback@mastry.io";
      }

      let html = htmlParam;
      let subject = `Session Report: ${this.studentSessionData.Name} - ${this.studentSessionData.eventInfo.EventFullName}`;
      let mailObject = {
        to,
        from,
        html,
        subject,
        cc,
        bcc,
      };
      apiHandler.sendMail(mailObject);
    },
    backToSessionListing() {
      this.studentUnderstandingRating = "";
      this.studentOralWritingRating = "";
      this.studentPreviousHomework = "";
      this.studentHomework = "";
      this.studentRemarks = "";
      this.currentStudent = {};
      this.selectedStudentForReview = {};
    },
    getStudentsDetailsForReview(studentDetails) {
      this.studentSessionData = this.selectedSession;
      this.currentStudent = studentDetails;
      this.sessionReviewDialog = true;
    },
    getStudentsDetails(sessionDetails) {
      if (sessionDetails == null) {
        this.allStudentsListBySession = [];
        this.currentStudent = {};
      } else {
        this.allStudentsListBySession = sessionDetails.IncludedAttendees;
      }
    },
    getStudentNames(attendeeList) {
      var names = [];
      attendeeList.map((attendee) => {
        names.push(attendee.FirstName);
      });
      return names.join(",");
    },
    createdSessionName: (item) =>
      item.Name + "  (" + item.eventInfo.EventFullName + ")",
    getAllSessionNames() {
      this.contentLoadedAuto = true;
      this.allSessionDetails = [];
      var currentTime = new Date().getTime();
      let body = {
        instanceId: INSTANCE_ID,
        clientId: CLIENT_ID,
        attendeeId: this.$store.state.user[0].id,
        data: {},
      };
      apiHandler
        .getAllSessionsByEvents(body)
        .then((result) => {
          result.data.data.forEach((sessionSnap) => {
            if (
              sessionSnap.IncludedAttendees &&
              sessionSnap.IncludedAttendees.length > 0
            ) {
              sessionSnap.AttendeeNames =
                this.getStudentNames(sessionSnap.IncludedAttendees) != undefined
                  ? this.getStudentNames(sessionSnap.IncludedAttendees)
                  : "No Student";
            } else {
              sessionSnap.AttendeeNames = "No Student";
            }
            if (currentTime >= sessionSnap.EndDate._seconds * 1000) {
              this.allSessionDetails.push(sessionSnap);
            }

            this.allSessionDetails.sort((a, b) =>
              a.StartDate._seconds > b.StartDate._seconds
                ? -1
                : b.StartDate._seconds > a.StartDate._seconds
                ? 1
                : 0
            );
            this.contentLoadedAuto = false;
          });
        })
        .catch((err) => {
          console.log(err);
          this.contentLoadedAuto = false;
        });
    },
    getStudentRatingSessionTime(date) {
      if (date) {
        return moment(new Date(date)).tz("Asia/Singapore").format("hh:mm A");
      } else return "";
    },
    getStudentRatingSessionDate(date) {
      if (date) {
        return moment(new Date(date)).format("MMM Do, YYYY");
      } else return "";
    },
    getAllTeacherDataByClient() {
      var self = this;
      (self.searchTeacher = ""), (self.teacherDetailsLoaded = true);
      self.teacherData = [];
      self.teacherTableHeaderData = [
        {
          text: "Name",
          value: "user_name",
          width: "200px",
          fixed: true,
        },
        {
          text: "Course Name",
          value: "course_name",
          width: "200px",
          fixed: true,
        },
        { text: "Email", value: "user_email", width: "200px", fixed: true },
        {
          text: "Contacts",
          value: "user_contact",
          width: "200px",
          fixed: true,
        },
        { text: "View Details", value: "details", width: "200px", fixed: true },
      ];
      let headers = {
        "Content-Type": "application/json",
      };
      let rqstData = {};

      rqstData = {
        key: {
          clientId: this.$store.state.client[0].id,
        },

        data: {
          reg_type: "Speaker",
        },
      };
      axios
        .post(
          "https://us-central1-e2medu.cloudfunctions.net/e2medu-v2-prd-get-users",
          rqstData,
          {
            headers: headers,
          }
        )
        .then((responseData) => {
          responseData.data.data.map((teacher, index) => {
            if (!teacher.user_email.includes("webspiders")) {
              // const checkUsername = (obj) => obj.email === teacher.user_email;
              // if (self.teacherData.some(checkUsername)) {
              //   var index = self.teacherData.findIndex(
              //     (_item) => _item.email === teacher.user_email
              //   );
              //   self.teacherData[index].courseName =
              //     self.teacherData[index].courseName +
              //     "," +
              //     teacher.course_name;
              // } else {
              teacher.details = true;
              teacher.id = index;
              self.teacherData.push(teacher);
              //}
            }
          });
          self.teacherData.sort((a, b) =>
            b.user_name > a.user_name ? -1 : b.user_name > a.user_name ? 1 : 0
          );

          self.teacherDetailsLoaded = false;
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    getStudentsCertificates(data) {
      bus.$emit("toggleLoader", true);
      if (data != null) {
        let headers = {
          "content-type": "application/json",
        };

        let rqstData = {};

        rqstData = {
          key: {
            clientId: this.$store.state.client[0].id,
          },

          data: {
            attendeeId: data.Id,
          },
        };
        axios
          .post(
            "https://us-central1-e2medu.cloudfunctions.net/e2medu-v2-prd-attendee-stat",
            rqstData,
            {
              headers: headers,
            }
          )
          .then((responseData) => {
            this.certificateData = [];
            responseData.data.data.map((course) => {
              course.last_session_end_date = this.SetTimeByZone(
                new Date(course.last_session_end_date * 1000).toUTCString(),
                moment.tz.guess()
              );
              course.completionPercentage = Math.round(
                (parseInt(course.attended_sessions) /
                  parseInt(course.purchased_sessions)) *
                  100
              );

              this.certificateData.push(responseData.data.data);
            });
            bus.$emit("toggleLoader", false);
          })
          .catch((error) => {
            console.log("Error:" + error);
            bus.$emit("toggleLoader", false);
          });
      } else {
        bus.$emit("toggleLoader", false);
        this.certificateData = [];
        this.clientCertificateSelector = true;
      }
    },
    getAllStudentListByClient() {
      this.loadStudent = true;
      let headers = {
        "Content-Type": "application/json",
      };
      let rqstData = {};

      rqstData = {
        key: {
          clientId: this.$store.state.client[0].id,
        },

        data: {
          reg_type: "Attendee",
        },
      };
      axios
        .post(
          "https://us-central1-e2medu.cloudfunctions.net/e2medu-v2-prd-get-users",
          rqstData,
          {
            headers: headers,
          }
        )
        .then((responseData) => {
          responseData.data.data.map((student) => {
            if (!student.user_email.includes("webspiders")) {
              this.allStudentsList.push({
                Id: student.user_id,
                Name: student.user_name.trim(),
                Email: student.user_email.trim(),
              });
            }
          });
          this.allStudentsList.sort((a, b) =>
            b.Name > a.Name ? -1 : b.Name > a.Name ? 1 : 0
          );
          this.loadStudent = false;
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    getCertificateDetails() {
      bus.$emit("toggleLoader", true);
      if (this.isClientAdmin() != true) {
        let headers = {
          "content-type": "application/json",
        };

        let rqstData = {};

        rqstData = {
          key: {
            clientId: this.$store.state.client[0].id,
          },

          data: {
            attendeeId: this.$store.state.user[0].id,
          },
        };
        axios
          .post(
            "https://us-central1-e2medu.cloudfunctions.net/e2medu-v2-prd-attendee-stat",
            rqstData,
            {
              headers: headers,
            }
          )
          .then((responseData) => {
            this.certificateData = [];
            responseData.data.data.map((course) => {
              course.last_session_end_date = this.SetTimeByZone(
                new Date(course.last_session_end_date * 1000).toUTCString(),
                moment.tz.guess()
              );
              course.completionPercentage = Math.round(
                (parseInt(course.attended_sessions) /
                  parseInt(course.purchased_sessions)) *
                  100
              );

              this.certificateData.push(responseData.data.data);
            });
            if (this.certificateData.length == 0) {
              this.noCertificateMsgShow = true;
            }
            bus.$emit("toggleLoader", false);
          })
          .catch((error) => {
            console.log("Error:" + error);
            bus.$emit("toggleLoader", false);
          });
      } else {
        bus.$emit("toggleLoader", false);
        this.getAllStudentListByClient();
        this.clientCertificateSelector = true;
      }
    },
    getHtmlToPdf(data) {
      bus.$emit("toggleLoader", true);
      var name = data.Name;
      var first_name = name.split(" ")[0];
      var last_name = name.substring(first_name.length).trim();
      var courseCompletionDate = data.last_session_end_date.slice(0, 12);
      var fileName = data.course_name.replace(/ /g, "_") + "_" + data.Name;
      let headers = {
        "Content-Type": "application/json",
        "x-api-key": "AIzaSyAvJ1oRjBZmLUeXPKtU9zm8GzO4-gOjmnk",
      };

      let rqstData = {};

      rqstData = {
        key: {
          instanceId: "OA_UAT",
          clientId: this.$store.state.client[0].id,
          eventId: data.course_id,
        },
        data: {
          path: "Features/ClientFeatures",
          htmlfield: "ClientCertificateHtml",
          filename: "Chess completion",
          replacements: {
            courseName: data.course_name,
            firstName: first_name,
            lastName: last_name,
            courseCompletionDate: courseCompletionDate,
          },
        },
      };
      axios
        .post(
          "https://us-central1-e2medu.cloudfunctions.net/e2medu-prd-generate-pdf",
          rqstData,
          {
            headers: headers,
            responseType: "blob",
          }
        )
        .then((response) => {
          let blob = new Blob([response.data], { type: "application/pdf" });
          let link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          link.download = fileName + ".pdf";
          bus.$emit("toggleLoader", false);
          link.click();
        })
        .catch((error) => {
          bus.$emit("toggleLoader", false);
          console.log("Error:" + error);
        });
    },
    resourceFiter(data) {
      this.filterByCategory = data == "ALL" ? "" : data;
    },
    downloadOrViewFile(resource) {
      bus.$emit("toggleLoader", true);
      if (resource.Type == "PDF" || resource.Type == "PPT") {
        this.downloadResourceFile(resource.ResourcePath, resource.ResourceName);
      } else {
        var data = {};
        if (resource.Type == "IMAGE") {
          data = {};
          data.url = resource.ResourcePath;
          data.type = "IMAGE";
          bus.$emit("toggleLoader", false);
          bus.$emit("chatResources", data);
        } else if (resource.Type == "VIDEO") {
          data = {};
          data.url = resource.ResourcePath;
          data.type = "VIDEO";
          bus.$emit("toggleLoader", false);
          bus.$emit("chatResources", data);
        }
      }
    },
    downloadResourceFile(url, fileName) {
      axios({
        method: "get",
        url: url,
        responseType: "arraybuffer",
      })
        .then((response) => {
          this.forceFileDownload(response, fileName);
        })
        .catch(() => console.log("error occured"));
    },
    forceFileDownload(response, fileName) {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName); //or any other extension
      document.body.appendChild(link);
      bus.$emit("toggleLoader", false);
      link.click();
    },
    getResourceForClient() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      var listRef = db
        .collection("OA_UAT/ClientList/Clients")
        .doc(obj.client[0].id)
        .collection("Resources");

      listRef.where("IsPublished", "==", true).onSnapshot((querySnapshot) => {
        this.clientResource = [];
        if (querySnapshot.docs.length > 0) {
          querySnapshot.forEach((doc) => {
            var data = doc.data();
            this.clientResource.push(data);
          });
        }
      });
    },
    getSessionDetailsBySessionId(sessionId, emailId) {
      this.sessionDetailTooltip = null;
      let headers = {
        "content-type": "application/json",
      };

      let rqstData = {};

      rqstData = {
        eventId: this.selectedCourse.EventId,
        sessionId: sessionId,
        email: emailId,
      };
      axios
        .post(
          "https://us-central1-e2medu.cloudfunctions.net/e2medu-v2-prd-participation-stat",
          rqstData,
          {
            headers: headers,
          }
        )
        .then((responseData) => {
          var start = this.SetTimeByZone(
            new Date(responseData.data.header.start_time * 1000).toUTCString(),
            "Asia/Singapore"
          );
          var end = this.SetTimeByZone(
            new Date(responseData.data.header.end_time * 1000).toUTCString(),
            "Asia/Singapore"
          );

          this.sessionDetailTooltip =
            start.slice(0, 18) + " - " + end.slice(13, 22);
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    getSessionIndividualFeedbacks(eventId) {
      let headers = {
        "content-type": "application/json",
      };

      let rqstData = {};

      rqstData = {
        eventId: eventId ? eventId : this.selectedCourse.EventId,
      };
      axios
        .post(
          "https://us-central1-e2medu.cloudfunctions.net/e2medu-v2-prd-course-reviews",
          rqstData,
          {
            headers: headers,
          }
        )
        .then((responseData) => {
          this.allFeedbackData = responseData.data;
          this.getStudentsFeedbackData();
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    getStudentsFeedbackData() {
      this.studentFeedbackData = [];
      this.feedbackTableHeaderData = [
        {
          text: "Session Name",
          value: "sessionName",
          width: "200px",
          fixed: true,
        },
        {
          text: "Start Date",
          value: "startDateTime",
          width: "200px",
          fixed: true,
        },
        { text: "End Date", value: "endDateTime", width: "200px", fixed: true },
        { text: "Student", value: "student", width: "200px", fixed: true },
        { text: "Feedback", value: "feedback", width: "200px", fixed: true },
      ];
      this.allFeedbackData.data.students.map((feedback) => {
        feedback.startDateTime = this.SetTimeByZone(
          new Date(feedback.startDate * 1000).toUTCString(),
          moment.tz.guess()
        );

        feedback.endDateTime = this.SetTimeByZone(
          new Date(feedback.endDate * 1000).toUTCString(),
          moment.tz.guess()
        );

        this.studentFeedbackData.push(feedback);
      });
    },
    getTeachersFeedbackData() {
      this.teacherFeedbackData = [];
      this.feedbackTableHeaderData = [
        {
          text: "Session Name",
          value: "sessionName",
          width: "200px",
          fixed: true,
        },
        {
          text: "Start Date",
          value: "startDateTime",
          width: "200px",
          fixed: true,
        },
        { text: "End Date", value: "endDateTime", width: "200px", fixed: true },
        // { text: "Student", value: "student", width: "200px", fixed: true },
        { text: "Teacher", value: "teacher", width: "200px", fixed: true },
        { text: "Feedback", value: "feedback", width: "200px", fixed: true },
      ];

      this.allFeedbackData.data.teachers.map((feedback) => {
        feedback.startDateTime = this.SetTimeByZone(
          new Date(feedback.startDate * 1000).toUTCString(),
          moment.tz.guess()
        );

        feedback.endDateTime = this.SetTimeByZone(
          new Date(feedback.endDate * 1000).toUTCString(),
          moment.tz.guess()
        );

        this.teacherFeedbackData.push(feedback);
      });
    },
    SetTimeByZone: function (strDateTime, timeZone) {
      var date = moment
        .tz(strDateTime, timeZone)
        .format("MMM DD, YYYY hh:mm A");
      return date;
    },
    openFeedbackDialog(data) {
      var dateTime = this.SetTimeByZone(
        new Date(data.date).toUTCString(),
        moment.tz.guess()
      );

      var html;
      if (location.host.includes("edulife")) {
        html = `<html lang="en-US"> <head> <link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,600;1,400;1,500&display=swap" rel="stylesheet"> <style>td {font-size:16px;font-weight:600;font-family: 'Poppins', sans-serif !important;} img{max-width:100%} </style> </head> <div class="" style="width:90%;margin:0 auto;background-color:#f2f2f2;padding:40px" > <div class="" style="width:600px;margin:0 auto;background-color:#ffffff;padding:40px" > <table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0" > <tbody> <tr> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;margin:0px;padding:0px;width:100%"> <tbody> <tr> <td style="padding-bottom:20px"> <a href="https://edulife.sg/home" target="_blank"> <img src="https://s3.amazonaws.com/unroll-images-production/projects%2F0%2F1623830177018-email-banner.jpg" width="600px"> </a> </td> </tr> </table> </tr> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:30px 10px 10px;font-family:'Lato',sans-serif;" align="left"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tbody> <tr> <td style="padding-right: 0px;padding-left: 0px;padding-bottom:15px" align="center"> <span style="font-size:18px;font-weight:600;border-bottom: 1px solid #000000;">SESSION REPORT</span> </td> </tr> </tbody> </table> </td> </tr> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding-top:40px;" align="left"> <table width="100%" cellpadding="0" cellspacing="0" border="0" style="font-size:16px;font-weight:600"> <tbody> <tr> <td style="padding-right: 0px;padding-left: 0px;" align="center"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tr> <td> <p style="">Session Date: <span style="font-weight: 300;font-family: arial;">${dateTime.slice(
          0,
          12
        )}</span> </p> </td> <td> <p style=""></p> </td> </tr> <tr> <td> <p style="">Student Name: <span style="font-weight: 300;font-family: arial;">${
          data.student
        }</span></p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="">Course Name: <span style="font-weight: 300;font-family: arial;"> ${
          data.eventName
        }</span></p> </td> <td> <p style=""> </p> </td> </tr> </table> </td> <td style="padding-right: 0px;" align="center"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tr> <td> <p style="">Session Time: <span style="font-weight: 300;font-family: arial;">${dateTime.slice(
          12,
          21
        )}</span></p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="">Teacher Name: <span style="font-weight: 300;font-family: arial;">${
          data.teacher
        }</span></p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="margin-left:5px"><span style="font-weight: 300;font-family: arial;">Session Name: ${
          data.sessionName
        }</span></p> </td> <td> <p style=""> </p> </td> </tr> </table> </td> </tr> </tbody> </table> </td> </tr> <tr><td style="width:100%"><p style="border-top: 1px solid #dfdfdf;margin: 0 !important;padding: 4px 0;line-height:0">&nbsp;</p></td></tr> <tr> <td style="padding-top:40px;"> <p>Understanding: ${
          data.studentUnderstandingRating
        }/10</p> <p>Oral/Written Class Performance: ${
          data.studentOralWritingRating
        }/10 </p> <p>Previous Assignment: ${
          data.studentPreviousHomework
        } </p> <p>Assignment : ${
          data.studentHomework
        } </p> <p>Additional Remark: ${
          data.studentRemarks
        } </p> </td> </tr> </tbody> </table> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;margin:0px;padding:0px;width:100%"> <tbody> <tr> <td style="padding:20px "> <img src="https://s3.amazonaws.com/unroll-images-production/projects%2F0%2F1623077639730-unnamed+%282%29.png" width="600px"> </td> </tr> </table> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;margin:0px;padding:0px;width:100%"> <tbody> <tr> <td> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%"> <tr> <td colspan="3" style="padding:0cm 0cm 0cm 0cm"> <p class="MsoNormal" align="center" style="text-align:center"> <span style="color:black"><a href="https://www.facebook.com/edulifesingapore" target="_blank"><span style="font-size:12.0pt;text-decoration:none"> <img border="0" width="18" height="18" style="width:.1875in;height:.1875in" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Ffacebook.png?alt=media" class="CToWUd"></span></a></span><span style="font-size:12.0pt;color:#222222"> </span><span style="color:black;padding:0 8px;"> <a href="https://www.instagram.com/edulifesg/" target="_blank" ><span style="font-size:12.0pt;text-decoration:none"> <img border="0" width="18" height="18" style="width:.1875in;height:.1875in" id="m_3276429931951355163m_4809426333270075598m_-7723710672828629258_x0000_i1027" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Finsta.png?alt=media" class="CToWUd"></span></a></span><span style="font-size:12.0pt;color:#222222"> </span><span style="color:black"> <a href="https://www.linkedin.com/in/edulife-singapore-b605a91b2/ " target="_blank"><span style="font-size:12.0pt;text-decoration:none"><img border="0" width="18" height="18" style="width:.1875in;height:.1875in" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Flinkdin.png?alt=media" class="CToWUd"></span></a></span> </p> <p align="center" style="margin-bottom:22.5pt;text-align:center"><span style="font-size:9.0pt;font-family:Times New Roman,serif;color:#222222">© Copyright EduLife 2021. All Rights Reserved<u></u><u></u></span></p> </td> </tr> </table> </td> </tr> </tbody> </table> </div> </div> </body> </html>`;
      } else {
        html = `<html lang="en-US"> <head> <link href="https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,600;1,400;1,500&display=swap" rel="stylesheet"> <style>td {font-size:16px;font-weight:600;font-family: 'Poppins', sans-serif !important;} img{max-width:100%} </style> </head> <div class="" style="width:90%;margin:0 auto;background-color:#f2f2f2;padding:40px" > <div class="" style="width:600px;margin:0 auto;background-color:#ffffff;padding:40px" > <table style="font-family:'Lato',sans-serif;" role="presentation" cellpadding="0" cellspacing="0" width="100%" border="0" > <tbody> <tr> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;margin:0px;padding:0px;width:100%"> <tbody> <tr> <td style="padding-bottom:20px"> <a href="https://www.mastry.io/" target="_blank"> <img src="https://mars.webspiders.com/Prototype/Mastry/mastry.png" alt="Mastry" width="600px"> </a> </td> </tr> </table> </tr> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding:30px 10px 10px;font-family:'Lato',sans-serif;" align="left"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tbody> <tr> <td style="padding-right: 0px;padding-left: 0px;padding-bottom:15px" align="center"> <span style="font-size:18px;font-weight:600;border-bottom: 1px solid #000000;">SESSION REPORT</span> </td> </tr> </tbody> </table> </td> </tr> <tr> <td style="overflow-wrap:break-word;word-break:break-word;padding-top:40px;" align="left"> <table width="100%" cellpadding="0" cellspacing="0" border="0" style="font-size:16px;font-weight:600"> <tbody> <tr> <td style="padding-right: 0px;padding-left: 0px;" align="center"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tr> <td> <p style="">Session Date: <span style="font-weight: 300;font-family: arial;">${dateTime.slice(
          0,
          12
        )}</span> </p> </td> <td> <p style=""></p> </td> </tr> <tr> <td> <p style="">Student Name: <span style="font-weight: 300;font-family: arial;">${
          data.student
        }</span></p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="">Course Name: <span style="font-weight: 300;font-family: arial;"> ${
          data.eventName
        }</span></p> </td> <td> <p style=""> </p> </td> </tr> </table> </td> <td style="padding-right: 0px;" align="center"> <table width="100%" cellpadding="0" cellspacing="0" border="0"> <tr> <td> <p style="">Session Time: <span style="font-weight: 300;font-family: arial;">${dateTime.slice(
          12,
          21
        )}</span></p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="">Teacher Name: <span style="font-weight: 300;font-family: arial;">${
          data.teacher
        }</span></p> </td> <td> <p style=""> </p> </td> </tr> <tr> <td> <p style="margin-left:5px"><span style="font-weight: 300;font-family: arial;">Session Name: ${
          data.sessionName
        }</span></p> </td> <td> <p style=""> </p> </td> </tr> </table> </td> </tr> </tbody> </table> </td> </tr> <tr><td style="width:100%"><p style="border-top: 1px solid #dfdfdf;margin: 0 !important;padding: 4px 0;line-height:0">&nbsp;</p></td></tr> <tr> <td style="padding-top:40px;"> <p>Understanding: ${
          data.studentUnderstandingRating
        }/10</p> <p>Oral/Written Class Performance: ${
          data.studentOralWritingRating
        }/10 </p> <p>Previous Assignment: ${
          data.studentPreviousHomework
        } </p> <p>Assignment : ${
          data.studentHomework
        } </p> <p>Additional Remark: ${
          data.studentRemarks
        } </p> </td> </tr> </tbody> </table> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%" style="border-collapse:collapse;margin:0px;padding:0px;width:100%"> <tbody> <tr> <td> <table align="center" border="0" cellpadding="0" cellspacing="0" width="100%"> <tr> <td colspan="3" style="padding:0cm 0cm 0cm 0cm"> <p class="MsoNormal" align="center" style="text-align:center"> <span style="color:black"><a href="https://www.facebook.com/Mastry-118511360415858" target="_blank"><span style="font-size:12.0pt;text-decoration:none"> <img border="0" width="18" height="18" style="width:.1875in;height:.1875in" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Ffacebook.png?alt=media" class="CToWUd"></span></a></span><span style="font-size:12.0pt;color:#222222"> </span><span style="color:black;padding:0 8px;"> <a href="https://www.instagram.com/mastry.io/" target="_blank" ><span style="font-size:12.0pt;text-decoration:none"> <img border="0" width="18" height="18" style="width:.1875in;height:.1875in" id="m_3276429931951355163m_4809426333270075598m_-7723710672828629258_x0000_i1027" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Finsta.png?alt=media" class="CToWUd"></span></a></span><span style="font-size:12.0pt;color:#222222"> </span><span style="color:black"> <a href="https://www.linkedin.com/company/mastry-io" target="_blank"><span style="font-size:12.0pt;text-decoration:none"><img border="0" width="18" height="18" style="width:.1875in;height:.1875in" src="https://firebasestorage.googleapis.com/v0/b/e2monair.appspot.com/o/OA_UAT%2Flinkdin.png?alt=media" class="CToWUd"></span></a></span> </p> <p align="center" style="margin-bottom:22.5pt;text-align:center"><span style="font-size:9.0pt;font-family:Times New Roman,serif;color:#222222">© Copyright Mastry 2021. All Rights Reserved<u></u><u></u></span></p> </td> </tr> </table> </td> </tr> </tbody> </table> </div> </div> </body> </html>`;
      }

      this.feedbackHtml = html;
      this.feedbackDialog = true;
    },
    getClassPerformanceDataByCourseId(courseDetails) {
      this.progressReport(courseDetails.EventId);
      this.getSessionIndividualFeedbacks(courseDetails.EventId);
    },
    getSessionsByEventId(courseDetails) {
      this.tableData = [];
      this.tableLoader = true;
      if (courseDetails != null) {
        let headers = {
          "content-type": "application/json",
        };

        let rqstData = {};

        rqstData = {
          eventId: courseDetails.EventId,
        };
        axios
          .post(
            "https://us-central1-e2medu.cloudfunctions.net/e2medu-v2-prd-course-stat",
            rqstData,
            {
              headers: headers,
            }
          )
          .then((responseData) => {
            this.tableData = responseData.data.data;
            this.tableLoader = false;
            this.getUpcomingSessions();
          })
          .catch((error) => {
            console.log("Error:" + error);
          });
      }
    },
    progressReport(eventId) {
      this.progressReports = [];
      this.progressReportsHeaders = [
        {
          text: "Session Name",
          value: "sessionName",
          width: "200px",
          fixed: true,
        },
        { text: "Student", value: "students", width: "200px", fixed: true },
        { text: "Teacher", value: "teachers", width: "200px", fixed: true },
        { text: "Feedback", value: "reviewed", width: "200px", fixed: true },
        {
          text: "View Details",
          value: "feedback",
          width: "200px",
          fixed: true,
        },
      ];
      this.tableLoader = true;

      let headers = {
        "content-type": "application/json",
      };

      let rqstData = {};

      rqstData = {
        eventId: eventId ? eventId : this.selectedCourse.EventId,
      };
      axios
        .post(
          "https://us-central1-e2medu.cloudfunctions.net/e2medu-v2-prd-course-feedback",
          rqstData,
          {
            headers: headers,
          }
        )
        .then((responseData) => {
          this.progressReports = responseData.data.data;
          this.tableLoader = false;
        })
        .catch((error) => {
          console.log("Error:" + error);
        });
    },
    getUpcomingSessions() {
      this.sessionData = [];
      this.classMonitoringHeaders = [
        {
          text: "Session Name",
          value: "sessionName",
          width: "200px",
          fixed: true,
        },
        {
          text: "Start Date",
          value: "startDateTime",
          width: "200px",
          fixed: true,
        },
        { text: "End Date", value: "endDateTime", width: "200px", fixed: true },
        { text: "Students", value: "students", width: "200px", fixed: true },
        { text: "Teacher", value: "teachers", width: "200px", fixed: true },
        {
          text: "Reschedule",
          value: "reschedule",
          width: "200px",
          fixed: true,
        },
      ];
      this.tableData.upcoming.data.map((session) => {
        session.startDateTime = this.SetTimeByZone(
          new Date(session.startDate * 1000).toUTCString(),
          moment.tz.guess()
        );

        session.endDateTime = this.SetTimeByZone(
          new Date(session.endDate * 1000).toUTCString(),
          moment.tz.guess()
        );
        session.reschedule = true;

        this.sessionData.push(session);
      });
      if (self.selectedUser != null) {
        this.sessionData = [];
        this.tableData.upcoming.data.map((session) => {
          if (
            session.studentIds &&
            session.studentIds.includes(self.selectedUser.user_id)
          ) {
            this.sessionData.push(session);
          } else if (
            session.teacherIds &&
            session.teacherIds.includes(self.selectedUser.user_id)
          ) {
            this.sessionData.push(session);
          }
        });
      }
      this.sessionData.sort((a, b) =>
        b.startDate > a.startDate ? -1 : b.startDate > a.startDate ? 1 : 0
      );
    },
    getPreSessions() {
      this.sessionData = [];

      this.classMonitoringHeaders = [
        {
          text: "Session Name",
          value: "session_name",
          width: "200px",
          fixed: true,
        },
        {
          text: "Start Date",
          value: "start_time",
          width: "200px",
          fixed: true,
        },
        { text: "End Date", value: "end_time", width: "200px", fixed: true },
        { text: "Email", value: "user_email", width: "200px", fixed: true },
        { text: "Name", value: "user_name", width: "200px", fixed: true },
        { text: "Type", value: "user_type", width: "200px", fixed: true },
        {
          text: "Duration",
          value: "total_duration",
          width: "200px",
          fixed: true,
        },
        {
          text: "Reschedule",
          value: "reschedule",
          width: "200px",
          fixed: true,
        },
      ];

      this.tableData.past.data.map((session, index) => {
        session.start_time = moment(
          new Date(session.start_time_utc * 1000)
        ).format("MMMM Do YYYY, h:mm a");

        session.end_time = moment(new Date(session.end_time_utc * 1000)).format(
          "MMMM Do YYYY, h:mm a"
        );
        session.reschedule = true;
        session.id = index;

        this.sessionData.push(session);
      });

      if (self.selectedUser != null) {
        this.sessionData = [];
        this.tableData.past.data.map((session) => {
          if (
            session.user_email &&
            session.user_email.includes(self.selectedUser.user_email)
          ) {
            this.sessionData.push(session);
          }
        });
      }
      this.sessionData.sort((a, b) =>
        b.start_time_utc < a.start_time_utc
          ? -1
          : b.start_time_utc < a.start_time_utc
          ? 1
          : 0
      );
    },
    openSubTabs(tab) {
      if (tab == "tab1") {
        this.selectedCourse = null;
        this.selectedSubTabs = 0;
      } else if (tab == "tab2") {
        this.selectedCourse = null;
        this.selectedSubTabs = 1;
      } else {
        this.selectedCourse = null;
        this.selectedSubTabs = 2;
      }
    },
    showHideTabs() {
      this.showTabs = !this.showTabs;
      this.selectedCourse = null;
      this.selectedSubTabs = 0;
    },
    getPosReports(title) {
      if (title == "User Report") {
        bus.$emit("toggleLoader", true);
        let headers = {
          Authorization: "Basic YXBpYWRtaW46I2FiY2QxMjM=",
          "content-type": "application/json",
        };

        axios
          .get("https://cms.edulife.sg/api/v1/user/report", {
            headers: headers,
          })
          .then((response) => {
            let data = response.data;
            data.map((users) => {
              users.Last_Accessed_On = this.SetTimeByZone(
                new Date(users.Last_Accessed_On * 1000).toUTCString(),
                moment.tz.guess()
              );

              users.Registered_On = this.SetTimeByZone(
                new Date(users.Registered_On * 1000).toUTCString(),
                moment.tz.guess()
              );
            });

            var contentWidth = this.formatExcelCols(data);

            var wscols = [];
            for (var i = 0; i < contentWidth.length; i++) {
              wscols.push({ wch: contentWidth[i].width });
            }
            let ws1 = XLSX.utils.json_to_sheet(data);
            ws1["!cols"] = wscols;

            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws1, "User Report");

            XLSX.writeFile(wb, "UserReport.xlsx");
            bus.$emit("toggleLoader", false);
          })

          .catch((error) => {
            console.log(error);
          });
      } else if (title == "Course Completion Report") {
        bus.$emit("toggleLoader", true);
        let headers = {
          "content-type": "application/json",
        };

        axios
          .get(
            "https://us-central1-e2medu.cloudfunctions.net/e2medu-v2-prd-user-stat",
            {
              headers: headers,
            }
          )
          .then((response) => {
            var responseData = response.data.data.filter(function (element) {
              return element.last_session_end_date > 0;
            });

            responseData.map((data) => {
              data.last_session_end_date = this.SetTimeByZone(
                new Date(data.last_session_end_date * 1000).toUTCString(),
                moment.tz.guess()
              );

              data.last_session_start_date = this.SetTimeByZone(
                new Date(data.last_session_start_date * 1000).toUTCString(),
                moment.tz.guess()
              );

              data.Registered_On = this.SetTimeByZone(
                new Date(data.Registered_On * 1000).toUTCString(),
                moment.tz.guess()
              );
              data.Last_Accessed_On = this.SetTimeByZone(
                new Date(data.Last_Accessed_On * 1000).toUTCString(),
                moment.tz.guess()
              );
              data.course_completed =
                data.course_completed == true ? "Yes" : "No";
            });

            var contentWidth = this.formatExcelCols(responseData);

            var wscols = [];
            for (var i = 0; i < contentWidth.length; i++) {
              wscols.push({ wch: contentWidth[i].width });
            }
            let ws1 = XLSX.utils.json_to_sheet(responseData);
            ws1["!cols"] = wscols;
            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws1, "Course Completion");

            XLSX.writeFile(wb, "CourseCompletion.xlsx");
            bus.$emit("toggleLoader", false);
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (title == "Trial Report") {
        bus.$emit("toggleLoader", true);
        let headers = {
          Authorization: "Basic YXBpYWRtaW46I2FiY2QxMjM=",
          "content-type": "application/json",
        };

        axios
          .get("https://cms.edulife.sg/api/v1/trial/report", {
            headers: headers,
          })
          .then((response) => {
            let data = response.data;

            var contentWidth = this.formatExcelCols(data);

            var wscols = [];
            for (var i = 0; i < contentWidth.length; i++) {
              wscols.push({ wch: contentWidth[i].width });
            }
            let ws1 = XLSX.utils.json_to_sheet(data);
            ws1["!cols"] = wscols;

            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws1, "Trial Report");

            XLSX.writeFile(wb, "TrialRequestReport.xlsx");
            bus.$emit("toggleLoader", false);
          })
          .catch((error) => {
            console.log(error);
          });
      } else if (title == "Order Report") {
        bus.$emit("toggleLoader", true);
        let headers = {
          Authorization: "Basic YXBpYWRtaW46I2FiY2QxMjM=",
          "content-type": "application/json",
        };

        axios
          .get("https://cms.edulife.sg/api/v1/order/report ", {
            headers: headers,
          })
          .then((response) => {
            let data = response.data;

            var contentWidth = this.formatExcelCols(data);

            var wscols = [];
            for (var i = 0; i < contentWidth.length; i++) {
              wscols.push({ wch: contentWidth[i].width });
            }
            let ws1 = XLSX.utils.json_to_sheet(data);
            ws1["!cols"] = wscols;

            var wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws1, "Order Report");

            XLSX.writeFile(wb, "OrderReport.xlsx");
            bus.$emit("toggleLoader", false);
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    getstudentsDataByCourseId(selectedCourse) {
      var self = this;
      this.students = [];
      this.headers = [
        { text: "NAME", value: "name", width: "200px", fixed: true },
      ];
      this.loadDashboardData = true;
      if (selectedCourse != null) {
        let headers = {
          "content-type": "application/json",
        };

        let rqstData = {};

        rqstData = {
          eventId: selectedCourse.EventId,
        };
        axios
          .post(this.APIs.CourseAttendance, rqstData, {
            headers: headers,
          })
          .then((responseData) => {
            responseData.data.header.map((session) => {
              self.headers.push({
                text: session.sessionName,
                value: session.sessionId,
                width: "200px",
              });
            });

            responseData.data.data.map((student) => {
              var data = student;
              data.name =
                student.RegistrationType != null
                  ? student.RegistrationType == "Attendee"
                    ? student.Name + " (Student)"
                    : student.Name + " (Teacher)"
                  : student.Name;
              delete data.AttendeeId;
              //delete data.Email;
              delete data.Sessions;
              self.students.push(data);
            });
            this.loadDashboardData = false;
          })
          .catch((error) => {
            console.log("Error:" + error);
          });
      }
    },
    refreshTokenBeforeEventCall() {
      self = this;
      firebase.auth().onAuthStateChanged(function (user) {
        if (user) {
          firebase
            .auth()
            .currentUser.getIdToken(true)
            .then((idToken) => {
              var decoded = jwt_decode(idToken);
              document.cookie = "token=";
              document.cookie = "token=" + idToken + ";";
              store.commit("setCurrentLoggedInTime", decoded.exp);
              store.commit("addToken", idToken);
              self.fetchCourseList();
            })
            .catch((err) => {
              console.log("token set error==", err);
            });
        }
      });
    },
    fetchCourseList() {
      this.loadCourse = true;
      let headers = {
        Authorization: "Bearer " + this.getSessionToken(),
        "content-type": "application/json",
      };

      axios
        .get(this.APIs.UserEvent, {
          headers: headers,
        })
        .then((response) => {
          this.loadCourse = false;
          var result = response.data.result;
          var i;
          var j;
          for (i = 0; i < result.length; ++i) {
            for (j = 0; j < result[i].events.length; j++) {
              if (result[i].client.ClientId == "C1591205467009") {
                if (result[i].events[j].IsPublished == true) {
                  this.allCourseList.push({
                    EventId: result[i].events[j].EventId,
                    EventFullName: result[i].events[j].EventFullName,
                  });
                }
              }
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    closeHandler() {
      this.allCourseList = [];
      this.selectedCourse = null;
      this.dialog = false;
      this.profileView = false;
      this.reportDialog = false;
      this.resourceDialog = false;
      this.certificateDialog = false;
      this.studentSessionData = {};
      this.currentStudent = {};
      this.sessionReviewDialog = false;
      this.rescheduleDialog = false;
    },
    routerHandler: function (routeVal) {
      if (routeVal.includes("http")) {
        window.open(routeVal);
      }
      // else if (routeVal.includes("profile")) {
      //   this.profileView = true;
      // }
      else {
        if (routeVal == "/session_cal") {
          if (this.$store.state.feedbackLastSession != null) {
            console.log("last feedback exist");
            this.$router.replace("/mainlobby" + routeVal);
            this.dialog = true;
          } else {
            this.$router.replace("/mainlobby" + routeVal);
            this.dialog = true;
          }
        } else {
          this.$router.replace("/mainlobby" + routeVal);
          this.dialog = true;
        }
      }
      console.log(routeVal);
    },
    clearstate: function () {
      let that = this;
      document.cookie = "vuid=; path=/;domain=.e2m.live;secure=true";
      document.cookie = "staysigned=";
      document.cookie = "userrole=";
      document.cookie = "userid=";
      if (this.$store.state.isSSO) {
        document.cookie = "AT=;domain=.edulife.sg;";
        this.$store.commit("addIsSSO", false);
        location.href = "https://edulife.sg/home?logout";
      }
      firebase
        .auth()
        .signOut()
        .then(
          function () {
            console.log("Signed Out");
          },
          function (error) {
            console.error("Sign Out Error", error);
          }
        )
        .finally(() => {
          if (this.isClientAdmin() != true) {
            location.href = "https://edulife.sg/home?logout";
          } else {
            location.href = "/";
          }
          that.$store.commit("ClearState", this);

          //location.href = "/";
        });
    },

    menuClicked(val) {
      if (val.Title == "Log Out" || val == "Log Out") {
        this.clearstate();
      }
      if (val.Title == "Select My Course") {
        this.$router.push({ name: "EventList" });
      }
      if (
        val.Title == "Share Your Session Feedback" ||
        val == "Share Your Session Feedback"
      ) {
        this.$router.replace({
          path: "/mainlobby" + "/session_cal",
          query: { menufeedback: true },
        });
        this.dialog = true;
      }
      if (val.Title == "My Reports") {
        this.getDashboardDetails();
        this.refreshTokenBeforeEventCall();
        this.getStudentList("Active");
        this.getAllUsersByClientId();

        this.reportDialog = true;
      }
      if (val.Title == "My Profile") {
        if (this.$store.state.user[0].userType == "Attendee") {
          (this.profileViewUrl = "https://edulife.sg/profile?light=1"),
            (this.profileViewHeaderText = "My Profile"),
            (this.profileView = !this.profileView);
        } else {
          this.$router.replace({
            path: "/mainlobby" + "/myprofile",
          });
          this.dialog = true;
        }
      }
      if (val.Title == "Resources" || val == "Resources") {
        this.fetchCourseList();
        this.getResourceForClient();
        this.resourceDialog = true;
      }
      if (val.Title == "My Certificates" || val == "My Certificates") {
        this.getCertificateDetails();
        this.certificateDialog = true;
      }
      if (val.Title == "Courses Feedback" || val == "Courses Feedback") {
        if (this.$store.state.user[0].userType == "Attendee") {
          this.profileViewUrl =
            "https://edulife.sg/profile?light=1&selectedTab=courses";
          this.profileViewHeaderText = "Courses Feedback";
          this.profileView = !this.profileView;
        }
      }
      if (val.Title == "Session Report" || val == "Session Report") {
        this.studentSessionData = {};
        this.currentStudent = {};
        this.selectedStudentForReview = {};
        this.selectedSession = {};
        this.studentUnderstandingRating = "";
        this.studentOralWritingRating = "";
        this.studentPreviousHomework = "";
        this.studentHomework = "";
        this.studentRemarks = "";
        this.getAllSessionNames();
        this.sessionReviewDialog = true;
      }
      if (val.Url.includes("https")) {
        window.open(val.Url);
      } else {
        if (val.IsDialog == false) {
          this.$router.push(val.Url);
          this.dialog = false;
        } else {
          this.$router.replace(val.Url);
          this.dialog = true;
        }
      }
    },
    getInitials() {
      if (this.$store.state.user.length > 0)
        return common.getInitials(this.$store.state.user[0].name);
      else "";
    },
    getMenuFont() {
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      if (obj !== undefined || obj === null) {
        return "";
      }
      if (obj.EventBranding == undefined || obj.EventBranding == null) {
        return "";
      }
      if (obj.EventBranding.length > 0) {
        return obj.EventBranding[0].fontBar == undefined
          ? ""
          : obj.EventBranding[0].fontBar;
      } else {
        return "";
      }
    },
    getClientDetails() {
      var self = this;
      var obj = JSON.parse(window.localStorage.getItem("my-app"));
      db.collection("OA_UAT/ClientList/Clients")
        .doc(obj.client[0].id)
        .collection("Features")
        .doc("PostLoginOptions")
        .get()
        .then(function (doc) {
          if (doc.exists) {
            self.showMenu = doc.data().MenuPosition
              ? doc.data().MenuPosition
              : "Side";
            self.menuLabel = doc.data().MenuLabel
              ? doc.data().MenuLabel
              : "My EduLife";
            //self.menuItems = doc.data().MenuItems ? doc.data().MenuItems : [];

            if (doc.data().MenuItems) {
              doc.data().MenuItems.map((menu) => {
                if (menu.Title == "My Reports") {
                  if (
                    self.$store.state.user[0].userType == "Speaker" ||
                    self.isClientAdmin() == true
                  ) {
                    self.menuItems.push(menu);
                  }
                } else if (menu.Title == "My Profile") {
                  if (self.isClientAdmin() == false) {
                    self.menuItems.push(menu);
                  }
                } else if (menu.Title == "My Courses") {
                  if (self.isClientAdmin() == false) {
                    self.menuItems.push(menu);
                  }
                } else if (menu.Title == "My Assignments") {
                  if (self.isClientAdmin() == false) {
                    self.menuItems.push(menu);
                  }
                } else if (menu.Title == "My Certificates") {
                  if (self.isClientAdmin() == false &&
                    self.$store.state.user[0].userType == "Attendee") {
                    self.menuItems.push(menu);
                  }
                } else if (menu.Title == "Share Your Session Feedback") {
                  if (
                    self.isClientAdmin() != true &&
                    self.$store.state.user[0].userType == "Attendee"
                  ) {
                    self.showSessionFeedbackMenu = true;
                    self.menuItems.push(menu);
                  }
                } else if (menu.Title == "Resources") {
                  if (self.isClientAdmin() == true) {
                    self.showResourceFeedbackMenu = true;
                    self.menuItems.push(menu);
                  }
                } else if (menu.Title == "Courses Feedback") {
                  if (
                    self.$store.state.user[0].userType == "Attendee" &&
                    self.isClientAdmin() != true
                  ) {
                    self.showCourseFeedbackMenu = true;
                    self.menuItems.push(menu);
                  }
                } else if (menu.Title == "Session Report") {
                  if (
                    self.$store.state.user[0].userType == "Speaker" &&
                    self.isClientAdmin() != true
                  ) {
                    self.showSessionReportMenu = true;
                    self.menuItems.push(menu);
                  }
                } else if (menu.Title == "My Certificates") {
                  if (
                    self.$store.state.user[0].userType == "Attendee" ||
                    self.isClientAdmin() == true
                  ) {
                    self.showCertificatesMenu = true;
                    self.menuItems.push(menu);
                  }
                } else if (menu.Title == "View More Courses") {
                  if (
                    self.$store.state.user[0].userType == "Attendee" &&
                    self.isClientAdmin() != true
                  ) {
                    self.menuItems.push(menu);
                  }
                } else {
                  self.menuItems.push(menu);
                }
              });
              self.menuItems.sort((a, b) =>
                a.DisplayOrder.toString().localeCompare(
                  b.DisplayOrder.toString()
                )
              );
            }
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style>
.overview-box-svg {
  height: 50px;
  width: 50px;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}

.overview-box-wrap {
  background: #fff;
  padding: 30px 25px;
  border-radius: 15px;
  box-shadow: 0 0 8px rgb(0 0 0 / 10%);
  height: 209px;
}

.overview-box-wrap h2 {
  font-size: 18px;
  font-weight: 400;
  margin: 0 !important;
  color: #a7a7a7 !important;
  padding-top: 5px;
}

.overview-box-wrap h3 {
  font-size: 25px;
  font-weight: 600;
  color: #090909;
  margin: 0 !important;
}

.overview-box-heading {
  font-size: 18px !important;
  font-weight: 300 !important;
}

.report-table table > tbody > tr > td:nth-child(1),
table > thead > tr > th:nth-child(1) {
  position: sticky !important;
  position: -webkit-sticky !important;
  left: 0;
  z-index: 9998;
  background: white;
}

.report-table table > tbody > tr > td {
  font-size: 16px !important;
}

.report-table table > thead > tr > th:nth-child(1) {
  z-index: 9999;
}
.auto-search-for-table {
  height: 45px;
  border: 1px solid #cbcbcb;
  margin-right: 15px;
}
.checkScroller {
  background: white;
}
.download-reports-btn {
  margin-bottom: 5px;
  justify-content: flex-end;
  align-items: flex-end;
  display: flex;
  margin-right: 10px;
}
.progress-number {
  position: absolute;
  right: 0;
  margin-top: 2px;
  top: 100%;
  font-size: 10px;
  display: inline-block;
  background: #79ba7e;
  color: #fff;
  padding: 2px 5px;
  border-radius: 50px;
}
.certificate-progress {
  position: relative;
}
.certificate-progress .progress-linear__bar__determinate.primary {
  overflow: hidden;
  position: absolute;
}
.certificate-progress .progress-linear__bar__determinate.primary:after {
  content: "";
  display: block;
  position: absolute;
  top: 0;
  left: 0;
  background-image: linear-gradient(
    -45deg,
    rgba(255, 255, 255, 0.125) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.125) 50%,
    rgba(255, 255, 255, 0.125) 75%,
    transparent 75%,
    transparent
  );
  background-size: 35px 35px;
  transition: width 4s ease-in-out;
  height: 100%;
  width: 100%;
}
.certificate-progress .progress-linear__bar__determinate.primary:after {
  -webkit-animation: cssProgressActive 2s linear infinite;
  animation: cssProgressActive 2s linear infinite;
}

@-webkit-keyframes cssProgressActive {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 35px 35px;
  }
}
@keyframes cssProgressActive {
  0% {
    background-position: 0 0;
  }
  100% {
    background-position: 35px 35px;
  }
}
.certificate {
  height: auto;
  width: 800px;
  margin: 0 auto;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}
.certificate img {
  width: 100%;
}
.certificate-name {
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  left: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 33px;
}

.certificate-name h2 {
  font-family: "Ruluko", sans-serif;
  font-size: 55px;
  padding: 0 6px;
  color: #000;
}
.certificate-coursename {
  position: absolute;
  bottom: 146px;
  left: 50%;
  transform: translateX(-50%);
  font-family: "Arial";
  font-weight: 600;
  color: #5f5f5f;
  font-size: 18px;
}
.certificate-date-wrap {
  position: absolute;
  bottom: 12%;
  left: 50%;
  transform: translateX(-50%);
}
.certificate-date-wrap p {
  font-family: "Arial";
  font-weight: 600;
  color: #5f5f5f;
  font-size: 18px;
}
.resource-types {
  cursor: pointer;
}
.resource-types:hover {
  background: #e8e8e8;
}
.logout-button-wrap {
  position: fixed;
  right: 0;
  top: 23px;
  z-index: 9;
}
.class-table-chart .table-scroll {
  position: sticky;
  top: 0;
  z-index: 999;
}
.profile-nav-drawer .v-list-item--active .v-list-item__title {
  color: #3f4ba2 !important;
}

.profile-nav-drawer .v-navigation-drawer__content {
  padding-bottom: 40px;
}

.profile-nav-drawer.theme--light.v-navigation-drawer {
  background-color: #f7f8fb !important;
}
.session-table-tab-wrap ul {
    padding: 0 24px !important;
}
.pos-wrapper {
  display: flex;
  margin: 0;
  padding: 0 24px !important;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.pos-list-items {
  list-style: none;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 31%;
  margin-right: 15px;
  height: 200px;
  background: rgba(53, 60, 150, 0.5);
  border-radius: 10px;
  margin-bottom: 20px;
}
.pos-list-items p {
  font-size: 22px;
  font-weight: 600;
  color: #fff;
  margin: 0;
}
.session-table-tab-wrap .v-item-group {
  margin: 0 20px;
}
.common-course-search {
  position: relative;
  background: #fff;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  margin: 0 20px;
  border-radius: 10px;
  box-shadow: 0 0 8px #d4d4d4;
}

.report-table-no-data {
  height: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.report-table-no-data p {
  font-size: 1.25rem;
  font-weight: 400;
  color: #8a8a8a;
  margin: 0;
}
.profile-dialog-wrap {
  overflow: hidden !important;
}
.clientLobby > p {
  margin-bottom: 0px !important;
}
.client-dialog {
  border-radius: 24px;
  /* max-width: 100% !important; */
  max-width: 80vw !important;
  overflow: hidden;
}
.client-dialog-profile {
  border-radius: 24px;
  min-width: 30%;
  width: fit-content !important;
  max-width: 50%;
  overflow: hidden;
}
</style>
<style scoped>
::-webkit-scrollbar {
  width: 6px;
}
::-webkit-scrollbar-track {
  background: lightgrey;
  border-radius: 10px;
}
::-webkit-scrollbar-track {
  border-radius: 10px;
}
::-webkit-scrollbar-thumb {
  background: rgb(90, 86, 86);
  border-radius: 10px;
}
::-webkit-scrollbar-thumb:hover {
  background: rgb(56, 54, 54);
  border-radius: 10px;
}
.theme--light.v-card .v-card__subtitle,
.theme--light.v-card > .v-card__text {
  color: rgba(0, 0, 0, 1) !important;
}
.v-card__subtitle,
.v-card__text {
  font-size: 1rem;
}
a {
  cursor: pointer;
}
.clientLobby {
  display: inline-block;
  position: relative;
  overflow: auto;
  align-content: center;
}
.clientLobby:after {
  content: "";
  position: absolute;
  /* Permalink - use to edit and share this gradient: https://colorzilla.com/gradient-editor/#ffffff+4,ffffff+96&1+0,0+7,0+94,1+100 */
  background: -moz-linear-gradient(
    left,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.43) 4%,
    rgba(255, 255, 255, 0) 7%,
    rgba(255, 255, 255, 0) 94%,
    rgba(255, 255, 255, 0.33) 96%,
    rgba(255, 255, 255, 1) 100%
  ); /* FF3.6-15 */
  background: -webkit-linear-gradient(
    left,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.43) 4%,
    rgba(255, 255, 255, 0) 7%,
    rgba(255, 255, 255, 0) 94%,
    rgba(255, 255, 255, 0.33) 96%,
    rgba(255, 255, 255, 1) 100%
  ); /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(
    to right,
    rgba(255, 255, 255, 1) 0%,
    rgba(255, 255, 255, 0.43) 4%,
    rgba(255, 255, 255, 0) 7%,
    rgba(255, 255, 255, 0) 94%,
    rgba(255, 255, 255, 0.33) 96%,
    rgba(255, 255, 255, 1) 100%
  ); /* W3C, IE10+, FF16+, Chrome26+, Opera12+, Safari7+ */
  filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#ffffff', endColorstr='#ffffff',GradientType=1 ); /* IE6-9 */
  width: 100%;
  height: 100%;
  left: 0;
  top: 0;
}
.v-sheet.v-card {
  border-radius: 24px !important;
}
::-webkit-scrollbar {
  height: 80%;
}
.class-image-wrap {
  position: relative;
  width: 100px;
  margin: 0 auto;
}
span.upload-class-profile-img {
  position: absolute;
  display: inline-flex;
  height: 30px;
  width: 30px;
  background: #4844d4;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  right: 0;
  bottom: 0;
  cursor: pointer;
}
.class-profile-wrap {
  text-align: center;
  padding: 30px 0;
}
h4.class-bar-msg {
  margin: 10px 0 0;
  font-weight: 300;
  color: #333;
  font-size: 1.25rem;
}
h3.class-bar-msg2 {
  margin: 8px 0 0;
  color: #333;
  font-weight: 600;
  font-size: 1.4rem;
}
p.class-bar-msg3 {
  color: #8a8a8a;
  font-size: 1rem;
  font-weight: 400;
  margin: 0;
}
.class-menu-list-wrap .v-list-item {
  margin-bottom: 15px !important;
}
.class-menu-icon p {
  font-size: 1.25rem;
  font-weight: 600;
  color: #000000;
  margin: 0 !important;
}
.class-left-menu {
  position: absolute;
  left: 55px;
  top: 0;
  z-index: 1;
}
.side-panel-bottom.sec {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: absolute;
  width: 100%;
  padding: 0 16px;
  bottom: 0;
  background: #f7f8fb;
  height: 48px;
  z-index: 99999;
}
.log-out-btn {
  cursor: pointer;
}
.log-out-btn p {
  margin: 0;
  font-size: 16px;
  color: #313131;
  font-weight: 400;
}
.class-product-version {
  position: relative;
}
/* .class-product-version:before {
  content: "";
  position: absolute;
  width: 90%;
  height: 1px;
  background: #dfdfdf;
  left: 50%;
  top: 0;
  transform: translateX(-50%);
} */
.class-product-version p {
  font-size: 1.25rem;
  color: #8a8a8a;
  font-style: italic;
  margin: 0 !important;
}
.reports-wrap .v-tabs--vertical > .v-tabs-bar .v-tab {
  height: 48px;
  width: 345px;
  justify-content: flex-start;
  font-size: 16px;
  color: #8a8a8a;
  padding: 30px 20px;
}
.reports-wrap .v-tabs--vertical > .v-tabs-bar .v-tab.v-tab--active {
  color: #000;
  background: #f1f3f2;
}
.reports-wrap .v-tabs-slider-wrapper {
  height: 60px !important;
}
.reports-wrap .v-tabs.v-tabs--vertical.theme--light {
  height: 100%;
  overflow-y: auto;
}
.reports-wrap .v-card__title {
  padding: 0 !important;
}
.reports-header h2 {
  padding: 15px 20px;
  color: #000;
  font-weight: 500;
  font-size: 1.85rem;
}
.report-toolbar {
  background: #fff;
  padding: 15px;
  margin: 0 20px;
  border-radius: 10px;
  box-shadow: 0 0 8px #d4d4d4;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.drop-tipe {
  width: 370px;
  border-radius: 6px;
  /* overflow: hidden; */
}
.drop-tipe .v-input {
  border-radius: 6px !important;
}
.report-search {
  border: 1px solid #dfdfdf;
  border-radius: 6px;
  padding: 0 5px;
}
.report-search input.search-input {
  width: 300px;
  height: 50px;
  padding: 0 12px 0 5px;
  font-size: 18px;
  font-weight: 400;
  color: #000;
}
.session-table-tab-wrap .theme--light.v-tabs > .v-tabs-bar {
  background-color: transparent !important;
}
.session-table-tab-wrap .v-tab.v-tab--active {
  color: #000;
}
.session-table-tab-wrap .v-slide-group__content.v-tabs-bar__content {
  margin: 0 20px;
}
.session-table-tab-wrap .v-tabs-slider-wrapper {
  height: 4px !important;
}
.session-table-tab-wrap .v-tab {
  font-size: 1rem;
}
</style>
<style>
.v-text-field__details {
  display: none !important;
}
.v-input__slot:before,
.v-input__slot:after {
  display: none !important;
}
.v-text-field--filled {
  border-radius: 6px 6px;
}
.report-table {
  margin: 0px 0px 0;
  height: 700px !important;
}
.report-table .v-data-table {height: 100% !important;}

.report-table .v-data-table__wrapper{ height: calc(100% - 60px) !important;}

.report-table table thead tr {
  border-top: 1px solid #dfdfdf;
}
.report-table table thead tr th span {
  font-weight: 700 !important;
  color: #000;
  font-size: 14px;
  text-align: center !important;
}
.report-table table tbody tr:nth-child(even) {
  background: #f8f8f8;
}
.report-table table tbody tr td {
  border-bottom: none !important;
}
/* .resources-drop .v-list-item {
  padding: 0 !important;
} */
.resources-drop .theme--light.v-list-item--active:before,
.resources-drop .theme--light.v-list-item--active:hover:before,
.resources-drop .theme--light.v-list-item:focus:before {
  opacity: 0 !important;
}
.resource-drop-inner p {
  color: #8a8a8a;
}
.resources-drop.feedback-drop:after {
  content: "";
  position: absolute;
  width: 95%;
  height: 1px;
  background: #8a8a8a;
  top: -9px;
  left: 50%;
  transform: translateX(-50%);
}

.resource-dialog .v-card__title {
  padding: 0 !important;
}
.resource-head {
  border-bottom: 1px solid #dfdfdf;
}
.resource-tab-area .v-tab {
  width: 345px;
  padding: 30px 21px;
  justify-content: flex-start;
  font-size: 15px;
  position: relative;
}

.resource-tab-area .v-tab.top-dast:after {
  position: absolute;
  content: "";
  height: 1px;
  width: 85%;
  left: 50%;
  bottom: 100%;
  transform: translateX(-50%);
  background: #dfdfdf;
}
.resource-tab-area .v-tab.v-tab--active {
  background: #f6f6f6;
  color: #000;
}
.resource-tab-area .v-tabs-slider-wrapper {
  height: 60px;
}
.resource-tab-area h2 {
  color: #000;
  font-weight: 600;
  font-size: 28px;
  padding: 10px 21px;
}
.class-tab-header {
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
}
.class-tab-header-left {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.class-tab-header-left h3 {
  font-weight: 600;
  color: #000;
  font-size: 25px;
  margin: 0;
}
.class-tab-header-left h5 {
  margin: 0;
  margin-left: 25px;
  font-weight: 400;
  color: #8a8a8a;
}
.class-tab-header-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.class-search-questions {
  background: #fff;
  border: 1px solid #dfdfdf;
  padding: 0 10px;
}
.class-search-questions input[type="text"] {
  background: transparent;
  width: 245px;
  height: 40px;
  padding: 0 8px;
  font-size: 16px;
  color: #000;
  line-height: 20px;
}

.class-filter-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
  height: 42px;
  border: 1px solid #dfdfdf;
  width: 112px;
  margin-left: 15px;
}
.class-filter-wrap p {
  margin: 0 !important;
  padding-left: 6px;
  font-weight: 400;
  font-size: 18px;
  color: #000;
}
.class-table-chart table {
  width: 100%;
  margin-top: 20px;
}
.class-table-chart table thead tr {
  background: #e6e6e6;
}
.class-table-chart table thead tr th {
  padding: 8px 10px;
  height: 10px;
  font-size: 16px;
  font-weight: 600;
  color: #000;
}
.class-table-chart tbody tr td {
  padding: 8px 10px;
}
.flie-wrap h4 {
  font-size: 18px;
  color: #000;
  font-weight: 400;
}
.class-table-chart a.link-name {
  font-size: 18px;
  text-decoration: underline;
  color: #2068ee;
  font-weight: 400;
}
.class-table-chart table tbody tr {
  background: #fff;
  border-bottom: 1px solid #dfdfdf;
}
.class-table-chart table tbody tr:last-child {
  border-bottom: 1px solid transparent;
}
.single-courses {
  background: #fff;
  padding: 20px;
  border-radius: 12px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.course-name {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.course-thumbnail {
  width: 130px;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  border-radius: 10px;
}
.course-short-desc {
  padding-left: 15px;
}
.course-short-desc h3 {
  font-weight: 400;
  color: #000;
  margin: 0;
  font-size: 1.55rem;
}
.course-short-desc p {
  margin: 0 !important;
  color: #8a8a8a;
  font-size: 1.18rem;
}
.session-class-price p {
  color: #000;
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0;
}
.back-area {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
p.back-btn {
  margin: 0;
  line-height: 0;
}
.class-course-details-table {
  background: #fff;
  width: 100%;
  padding: 15px;
  margin-top: 20px;
  border-radius: 10px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
}
.class-course-details-table table {
  width: 100%;
}
.class-course-details-table table tbody tr td {
  border: 1px solid #dfdfdf;
  padding: 10px;
  font-size: 16px;
  font-weight: 400;
}
.resource-tab-area .v-tabs {
  height: 100%;
}
.resource-tab-area .v-window__container {
  height: 100%;
}
.date-desc h4 {
  display: block;
  margin: 10px 0 0;
  font-weight: 500;
  font-size: 18px;
  color: #000;
}
.single-remaining-session {
  width: 100%;
  background: #fff;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.1);
  border-radius: 11px;
  padding: 20px;
  margin-top: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.remaining-session-details {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.class-session-thubmnail {
  height: 100px;
  width: 150px;
  overflow: hidden;
  border-radius: 10px;
}
.remaining-session-status {
  padding-left: 15px;
}

.remaining-session-status p {
  margin: 0 0 10px 0;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  color: #000;
  font-weight: 400;
  font-size: 14px;
}
.remaining-session-status p span {
  height: 11px;
  width: 10px;
  background: #fdc62b;
  display: inline-block;
  border-radius: 50%;
  margin-right: 4px;
}
.remaining-session-status h4 {
  font-weight: 400;
  font-size: 1.25rem;
  color: #000;
  margin-bottom: 4px;
}
.remaining-session-status h3 {
  color: #000;
  font-weight: 500;
  font-size: 1.6rem;
  margin: 0;
}
.tat-session-class p {
  margin-bottom: 7px;
  font-weight: 400;
  font-size: 1.15rem;
}
.date-desc {
  margin-top: 15px;
}
.resource-tab-area .v-window__container {
  height: 100%;
  overflow-y: auto;
}
.class-table-chart tbody tr td button {
  width: 100px;
  height: 35px !important;
  font-size: 12px !important;
}
@media only screen and (min-width:1366px) and (max-width:1440px) {
   /*--------------EduLife--------------*/
    .report-table {margin: 0px 0px 0; height: 434px !important;}
    /*--------------EduLife--------------*/
}
@media only screen and (min-width:1440px) and (max-width:1600px) {
   /*--------------EduLife--------------*/
    .report-table {margin: 0px 0px 0; height: 600px !important;}
    /*--------------EduLife--------------*/
}
@media only screen and (min-width:768px) and (max-width:1200px) {
   /*--------------EduLife--------------*/
    .report-table {margin: 0px 0px 0; height: 463px !important;}
    /*--------------EduLife--------------*/
}
</style>